<template>
  <div id="map-view-container">
    <transition name="expand-toolbar" v-on:after-enter="afterEnter">
      <div id="map-view-toolbar" v-if="toolbarVisible" class="d-block">
        <b-row class="bg-light m-0 p-0">
          <b-col class="p-0">
            <map-horizontal-toolbar
              ref="mapHorizontalToolbar"
              v-on:move-back="moveBack"
              v-on:move-forward="moveForward"
              v-on:show-full-range="showFullRange"
              v-on:show-overview-map="showOverviewMap"
              v-on:show-attributes-table="showAttributesTable"
              v-on:toggle-select-mode="toggleSelectMode"
              :disable-edit-mode-actions="editModeLayerHidden"
              :active-layer-type="activeLayerType"
              :isEditing="isEditing"
              :disableEditSessionActions="!canUseCache"
              @toggle-request-notification="toggleRequestNotification"
              @add-feature="startAddFeatureDraw"
              @edit-feature="startEditFeatureDraw"
              @delete-feature="startDeleteDraw"
              @copy-feature="copyFeature"
              @remove-feature="removeFeature"
              @copy-fragment="copyFragment"
              @show-historical-data="showHistoricalData(true)"
              @toogle-set-feature-geometry-tool="
                startSetFeatureGeometryInteraction
              "
              @toggle-mismatch-application-visibility="
                toggleMismatchApplicationVisibility
              "
            >
            </map-horizontal-toolbar>
          </b-col>
        </b-row>
        <b-collapse id="archive-layers-timeline" :value="historyTimelineActive">
          <b-row class="m-1"
            ><b-col><archive-layers-timeline></archive-layers-timeline></b-col
          ></b-row>
        </b-collapse>
      </div>
    </transition>
    <div class="map-view">
      <div ref="map" id="map" tabindex="0"></div>
      <div id="edit-mode-overlay" :class="{ 'd-none': hideEditModeOverlay }">
        <h3>Przybliż, aby edytować</h3>
      </div>
      <feature-dropdown></feature-dropdown>
      <feature-popup v-show="!isMobileDevice"></feature-popup>
      <multiple-feature-popup v-show="!isMobileDevice"></multiple-feature-popup>

      <div class="panel-container">
        <resizable-panel
          ref="tools"
          position="left"
          orientation="vertical"
          :width="20"
          :resizingStep="20"
          :maxWidth="20"
          :togglerMarginVertical="getTogglerMargin"
          :is-expanded="leftResizablePanelExpanded"
          @expanded-changed="leftPanelExpandUpdate"
          @panel-resized="leftPanelResized"
          class=""
          v-if="!isMobileVersion || !rightResizablePanelExpanded"
        >
          <sidebar-search-panel
            v-if="searchPanelVisible"
            accordion="left-panel"
          ></sidebar-search-panel>

          <mismatch-application
            v-if="
              mismatchApplicationVisible &&
              $context.hasPermission('Discrepancies_registry')
            "
            @mistmachLayerClear="clearMismatchDrawInteractionSource"
            @mismatchEndInteraction="endMismatchInteraction"
            @mismatchCancel="toggleMismatchApplicationVisibility"
            ref="mismatch"
            accordion="left-panel"
          ></mismatch-application
          ><manual-import
            v-if="manualImportPanelVisible"
            ref="manualImport"
            accordion="left-panel"
          ></manual-import>

          <pole-analysis
            v-if="poleAnalysisReady"
            accordion="left-panel"
          ></pole-analysis>
          <pole-analysis-feature-geometry
            v-if="poleAnalysisReady"
            accordion="left-panel"
          ></pole-analysis-feature-geometry>
          <road-lane-analysis
            v-if="roadLaneAnalysisStarted"
            accordion="left-panel"
          ></road-lane-analysis>
          <road-lane-analysis-geometry
            v-if="roadLaneAnalysisStarted && !roadLaneAnalysisDrawingEnded"
            accordion="left-panel"
          ></road-lane-analysis-geometry>
          <!-- <map-objects-geometry
            v-if="showObjectGeometry"
            :objects="editedObjects"
            :high-resolution="highMapResoulution"
            accordion="left-panel"
          ></map-objects-geometry> -->
          <broadband-connection-analysis
            v-if="connectionAnalysisLaunched"
            accordion="left-panel"
          ></broadband-connection-analysis>
          <broadband-connection-feature-geometry
            v-if="connectionAnalysisLaunched"
            accordion="left-panel"
          ></broadband-connection-feature-geometry>
          <historical-data
            ref="historicalData"
            v-if="isHistoryDataMode"
            @hide-historical-data="showHistoricalData(false)"
            accordion="left-panel"
          ></historical-data>
          <set-feature-geometry-tool
            v-if="showSetFeatureGeometryTool"
            accordion="left-panel"
          ></set-feature-geometry-tool>

          <div id="left-panel-placeholder" v-show="!anyToolActivated">
            <span class="placeholderWarning">Nie wybrano narzędzi mapy.</span>
          </div>
        </resizable-panel>

        <!-- <div class="map-objects-group">
        </div>   -->
        <div id="map-zoom"></div>
        <!-- <modify-menu /> -->
        <div
          style="
            display: -webkit-flex;
            display: flex;
            -webkit-flex-direction: column;
            flex-direction: column-reverse;
            min-width: 50%;
            height: 100%;
            -webkit-flex: 1;
            flex: 1;
          "
          class="d-none d-lg-flex d-xl-flex"
        >
          <resizable-panel
            style="z-index: 9999"
            @set-lower-higher="setLowerHigher"
            position="bottom"
            orientation="horizontal"
            :height="attributeTableHeight"
            :togglerMarginVertical="0"
            :resizingStep="50"
            :maxHeight="100"
            v-show="featuresTableActive"
            :ref="'resizable-attr-table'"
            @panel-resized="bottomPanelResized"
          >
            <attributes-table
              ref="attributes-table"
              :reload="attributesTableReload"
              :disable-edit-mode-actions="editModeLayerHidden"
              @edited-data="handleEditedData"
            ></attributes-table>
          </resizable-panel>
          <div id="overview-map"></div>
          <div class="map-objects-group">
            <search-panel-results
              @toggle-object-details="toggleObjectDetails"
              id="search-panel-results"
              v-if="
                searchPanelVisible &&
                (searchResultsLoading ||
                  (searchLayersItems && searchLayersItems.length > 0))
              "
            ></search-panel-results>
            <map-coordinates></map-coordinates>
          </div>
        </div>

        <resizable-panel
          ref="legend"
          position="right"
          :togglerMarginVertical="getTogglerMargin"
          orientation="vertical"
          :width="20"
          :resizingStep="20"
          :maxWidth="20"
          @expanded-changed="rightPanelExpandUpdate"
          v-if="mapMounted && (!isMobileVersion || !leftResizablePanelExpanded)"
          class=""
          @panel-resized="rightPanelResized"
        >
          <system-layers
            v-if="!contextIsAnonymous"
            @set-layer-extent="setExtent"
            accordion="right-panel"
          ></system-layers>
          <mvt-layers
            v-if="!contextIsAnonymous"
            @set-layer-extent="setExtent"
            accordion="right-panel"
          ></mvt-layers>
          <pwid-layers
            v-if="!contextIsAnonymous"
            @set-layer-extent="setExtent"
            accordion="right-panel"
          ></pwid-layers>
          <archive-layers
            v-if="!contextIsAnonymous"
            @set-layer-extent="setExtent"
            accordion="right-panel"
          ></archive-layers>
          <user-layers
            @set-layer-extent="setExtent"
            accordion="right-panel"
          ></user-layers>
          <compositions
            @set-layer-extent="setExtent"
            accordion="right-panel"
            @toggled="onCompositionPanelToggled"
          ></compositions>
          <background-layers accordion="right-panel"></background-layers>
          <add-wms-service accordion="right-panel"></add-wms-service>
          <right-panel-toolbar></right-panel-toolbar>
        </resizable-panel>
      </div>

      <set-centre-window v-on:set-centre="setCentre"></set-centre-window>
      <demand-export-window
        v-on:export-demand="exportDemand"
      ></demand-export-window>
      <demand-form-window
        v-on:publish-demand="publishDemand"
        v-if="demandFormVisible"
      ></demand-form-window>
      <search-result-filter-window
        @filterApplied="applyFilterToMap"
      ></search-result-filter-window>
      <object-detail-info-window></object-detail-info-window>
      <add-layer-from-service-window></add-layer-from-service-window>
      <map-shorcuts-window></map-shorcuts-window>
      <get-layer-from-file-window></get-layer-from-file-window>
      <ask-for-archive-data></ask-for-archive-data>
      <download-template></download-template>
      <report-wizard></report-wizard>
      <export-to-file></export-to-file>
      <spatial-analysis-modal></spatial-analysis-modal>
      <spatial-tabs></spatial-tabs>
      <zoom-to-own-range-window
        v-on:set-range="setRange"
      ></zoom-to-own-range-window>
      <report-demand-dialog
        v-if="reportDemandPopupVisible"
      ></report-demand-dialog>
      <map-permalinks-modal :map="map"></map-permalinks-modal>
    </div>

    <feature-popup-mobile v-show="isMobileDevice"></feature-popup-mobile>
    <loading-overlay
      :active="poleAnalysisWaitingForResponse"
      :is-full-page="true"
    ></loading-overlay>
    <loading-overlay
      :active="gettingFeatureInfo"
      :is-full-page="true"
    ></loading-overlay>
    <confirmation-window ref="confirmationWindow"></confirmation-window>
    <layer-activation-confirmation-modal></layer-activation-confirmation-modal>
    <context-assistant-modal></context-assistant-modal>
    <copy-features-modal
      v-if="Boolean(activeLayer && selectedFeatures.length)"
      :selectedFeaturesCount="selectedFeatures.length"
      :showModal="showCopyFeaturesModal"
      @hide="showCopyFeaturesModal = false"
      @copy-selected-features="copyFeaturesToLayer"
    />
    <ConfirmationWindow ref="confirmationModal" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  ADD_FEATURE_POINT,
  BEGIN_SET_FEATURE_GEOMETRY,
  EDIT_SESSION_ADD_FEATURE,
  EDIT_SESSION_DELETE_FEATURE,
  EDIT_SESSION_EDIT_FEATURE,
  EDIT_SESSION_EDIT_FEATURES,
  EDIT_SESSION_GET_FEATURE_GEOMETRY,
  EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY,
  EXPORT_DEMAND,
  FETCH_ALL_LAYERS,
  KEYSHORTCUTS_FETCH,
  MAP_CURRENT_VIEW_SET,
  MAP_NEXT_VIEW_MOVE,
  MAP_PREVIOUS_VIEW_MOVE,
  MAP_SELECTION_APPLY,
  MAP_SELECTION_CLEAR,
  MILEAGE_SEARCH_LAYER_ADD,
  MILEAGE_SEARCH_LAYER_APPEND_FEATURES,
  OTHER_TEMPORARY_LAYER_ADD,
  POINT_CHANGED,
  PUBLISH_DEMAND,
  READ_ONLY_GET,
  RESPONSIVENESS_MANAGER_TRIGGER,
  ROAD_LANE_FEATURE_ADD_POINT,
  ROAD_LANE_FEATURE_END_DRAWING,
  // EDIT_SESSION_CHECK_IF_VALID,
  SEARCH_LAYER_ADD_OR_EDIT,
  SEARCH_OBJECTS_WFS_GET,
  SELECT_MODE_TOGGLE,
  SET_FEATURE_GEOMETRY_ADD_POINT,
  SINGLE_CLICK_SELECTION_APPLY,
  TEMPORARY_LAYER_REMOVE,
  TERYT_SEARCH_LAYER_ADD,
  TERYT_SEARCH_LAYER_APPEND_FEATURES,
  TOOLS_FETCH,
  VIEW_SETTINGS_CLEAR,
  VIEW_SETTINGS_LOAD,
  VIEW_SETTINGS_SAVE,
  WMS_GET_FEATURE_INFO,
  RESET_FOCUSED_FEATURE_ID,
  ACTIVATE_LAYER,
} from '../store/actions.type';

import {
  ARCHIVE_LAYERS_EXPANDED_SET,
  BACKGROUND_LAYERS_EXPANDED_SET,
  COMPOSITION_LAYERS_EXPANDED_SET,
  CONNECTION_ADD_FEATURE_POINT,
  CONNECTION_POINT_CHANGED,
  CONNECTION_SET_FEATURE_ENDING,
  CUSTOM_LAYERS_EXPANDED_SET,
  DATA_FEED_ID_SET,
  DATA_FEED_NO_GEOMETRY_LAYER_ID_SET,
  DATA_FEED_TYPE_SET,
  DISPLAY_CLOSEST_OBJECT_INFO,
  FEATURES_DICTIONARIES_SET,
  FEATURES_OFFSET_SET,
  FEATURES_TABLE_META_SET,
  FEATURES_SET,
  FEATURES_TILE_LAYERS_FEATURES_SET,
  LEFT_RESIZABLE_PANEL_EXPAND_CHANGE,
  MANUAL_IMPORT_FOCUS_FEATURE_ID_SET,
  MANUAL_IMPORT_MAP_TOOLS_SET,
  MAP_HISTORY_DATA_MODE_SET,
  MAP_RESOLUTION_SET,
  MAP_ZOOM_MODE_TOGGLE,
  MAP_ZOOM_SET,
  MISMATCH_AREA_SET,
  MISMATCH_POINT_SET,
  PWID_LAYERS_EXPANDED_SET,
  REPORT_DEMAND_POPUP_SHOW,
  REPORT_VALIDATION_CHOOSEN_OBJECT_PROPERTIES_SET,
  REPORTS_RANGE_SET,
  RESIZABLE_PANEL_FORCE_EXPANDED_SET,
  RIGHT_RESIZABLE_PANEL_EXPAND_CHANGE,
  ROAD_LANE_FEATURE_SET_ENDING,
  SEARCH_ADDRESS_SET_SELECTED_OBJECT,
  SEARCH_MODE_BY_GEOMETRY_DISABLE,
  SEARCH_PANEL_SET_ITEMS,
  SELECT_FEATURE_POPUP_HIDE,
  SET_FEATURE_ENDING,
  SET_FEATURE_GEOMETRY_FEATURE_SET_ENDING,
  SET_FEATURES_WITH_COORDINATES,
  SYSTEM_LAYERS_EXPANDED_SET,
  USER_LAYERS_EXPANDED_SET,
  VIEW_CENTER_SET,
  WINDOW_NOTIFICATION_SHOW,
  MVT_LAYERS_EXPANDED_SET,
} from '../store/mutations.type';

import AddLayerFromServiceWindow from './AddLayerFromService';
import AttributesTable from './AttributesTable.vue';
import CopyFeaturesModal from './CopyFeaturesModal.vue';
import Compositions from './Compositions';
import MapCoordinates from './Coordinates';
import DemandExportWindow from './DemandExport';
import DemandFormWindow from './DemandForm';
import DownloadTemplate from './DownloadTemplate';
import GetLayerFromFileWindow from './GetLayerFromFile';
import ArchiveLayersTimeline from './HistoryTimeline/ArchiveLayersTimeline.vue';
import MapHorizontalToolbar from './HorizontalToolbar';
import Layers from './Layers';
import MapShorcutsWindow from './MapShortcuts';
import ResizablePanel from './ResizablePanel';
import SearchPanelResults from './SearchPanelResults';
import SearchResultFilterWindow from './SearchResultFilter';
import SetCentreWindow from './SetCentre';
import SidebarSearchPanel from './SidebarSearchPanel';
// import MapObjectsGeometry from './MapObjectsGeometry';
import { feature } from '@turf/helpers';
import Collection from 'ol/Collection';
import Feature from 'ol/Feature';
import OLMap from 'ol/Map';
import Overlay from 'ol/Overlay';
import View from 'ol/View';
import { defaults } from 'ol/control';
import MousePosition from 'ol/control/MousePosition';
import OverviewMap from 'ol/control/OverviewMap';
import ScaleLine from 'ol/control/ScaleLine';
import { format } from 'ol/coordinate';
import {
  always,
  pointerMove,
  singleClick,
  never,
  primaryAction,
} from 'ol/events/condition';
import { buffer } from 'ol/extent';
import WKT from 'ol/format/WKT';
import {
  Circle,
  LineString,
  MultiLineString,
  MultiPolygon,
  Point,
  Polygon,
} from 'ol/geom';
import { inflateCoordinatesArray } from 'ol/geom/flat/inflate';
import { DragZoom, Draw, Modify, Select, Snap } from 'ol/interaction';
import { createBox } from 'ol/interaction/Draw';
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom';
import { get, transform, transformExtent } from 'ol/proj';
import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { getArea, getDistance } from 'ol/sphere.js';
import {
  Circle as CircleStyle,
  Fill,
  Icon,
  RegularShape,
  Stroke,
  Style,
  Text,
} from 'ol/style';
import { getUid } from 'ol/util';
import LoadingOverlay from 'vue-loading-overlay';
import { Api as ApiSlowniki } from '../api/api-slowniki';
import { Api as ApiTableMeta } from '../api/api-tablemeta';
import { Api as LayersApi } from '../api/api-warstwy.js';
import { Api as ZglaszaniePopytuApi } from '../api/api-zglaszanie-popytu.js';
import { Api as ApiSessionCache } from '../api/api-session-cache.js';
import { KeyShortcuts } from '../common/keyShortcuts';
import { CoordinateSystems } from '../common/mapEnums';
import { generateFeatureId } from '../common/randomId';
import { MODE_POINT } from '../common/selectModes';
import ArchiveLayers from '../components/ArchiveLayers.vue';
import BackgroundLayers from '../components/BackgroundLayers';
import ContextAssistantModal from '../components/ContextAssistantModal';
import LayerActivationConfirmationModal from '../components/LayerActivationConfirmationModal';
import PwidLayers from '../components/PwidLayers.vue';
import RightPanelToolbar from '../components/RightPanelToolbar';
import SystemLayers from '../components/SystemLayers';
import MvtLayers from '../components/MvtLayers';
import UserLayers from '../components/UserLayers';
import MapBackgrounds from '../models/MapBackgrounds';
import AskForArchiveData from './AskForArchiveData';
import BroadbandConnectionAnalysis from './BroadbandConnectionAnalysis';
import BroadbandConnectionFeatureGeometry from './BroadbandConnectionFeatureGeometry';
import ConfirmationWindow from './ConfirmationWindow';
import ExportToFile from './ExportToFile';
import FeaturePopup from './FeaturePopup';
import FeatureDropdown from './FeatureDropdown';
import FeaturePopupMobile from './FeaturePopupMobile';
import HistoricalData from './HistoricalData';
import ManualImport from './ManualImport.vue';
import MapPermalinksModal from './MapPermalinksModal.vue';
import MismatchApplication from './MismatchApplication';
import MultipleFeaturePopup from './MultipleFeaturePopup';
import ObjectDetailInfoWindow from './ObjectDetailInfoWindow';
import PoleAnalysis from './PoleAnalysis';
import PoleAnalysisFeatureGeometry from './PoleAnalysisFeatureGeometry';
import ReportDemandDialog from './ReportDemandDialog.vue';
import ReportWizard from './ReportWizard/ReportWizard';
import RoadLaneAnalysis from './RoadLaneAnalysis';
import RoadLaneAnalysisGeometry from './RoadLaneAnalysisGeometry';
import SetFeatureGeometryTool from './SetFeatureGeometryTool';
import SpatialAnalysisModal from './SpatialAnalysis/Modal';
import SpatialTabs from './SpatialTabs';
import TemporaryLayers from './TemporaryLayers';
import ZoomToOwnRangeWindow from './ZoomToOwnRangeWindow';
import GeoJSON from 'ol/format/GeoJSON';
import AddWmsService from './AddWmsService.vue';

const numberOfStepsInHistory = 10;

export default {
  name: 'MapView',
  components: {
    DemandFormWindow,
    DemandExportWindow,
    SearchResultFilterWindow,
    ResizablePanel,
    MapHorizontalToolbar,
    ArchiveLayersTimeline,
    Compositions,
    Layers,
    MapCoordinates,
    GetLayerFromFileWindow,
    SetCentreWindow,
    AddLayerFromServiceWindow,
    MapShorcutsWindow,
    SidebarSearchPanel,
    SearchPanelResults,
    DownloadTemplate,
    AttributesTable,
    // MapObjectsGeometry,
    ReportWizard,
    FeaturePopup,
    FeatureDropdown,
    FeaturePopupMobile,
    MultipleFeaturePopup,
    ExportToFile,
    SpatialAnalysisModal,
    MismatchApplication,
    ManualImport,
    PoleAnalysis,
    TemporaryLayers,
    AskForArchiveData,
    SpatialTabs,
    ZoomToOwnRangeWindow,
    PoleAnalysisFeatureGeometry,
    LoadingOverlay,
    RoadLaneAnalysis,
    RoadLaneAnalysisGeometry,
    BroadbandConnectionAnalysis,
    BroadbandConnectionFeatureGeometry,
    HistoricalData,
    ConfirmationWindow,
    SetFeatureGeometryTool,
    LayerActivationConfirmationModal,
    ContextAssistantModal,
    SystemLayers,
    MvtLayers,
    PwidLayers,
    ArchiveLayers,
    UserLayers,
    BackgroundLayers,
    RightPanelToolbar,
    ReportDemandDialog,
    ObjectDetailInfoWindow,
    MapPermalinksModal,
    feature,
    ConfirmationWindow,
    AddWmsService,
    CopyFeaturesModal,
  },
  data: function () {
    return {
      isEditing: false,
      modifyInteraction: null,
      filterCriteria: null,
      map: undefined,
      mapInset: {
        bottom: 0,
        right: 0,
        left: 0,
      },
      mousePositionControl: undefined,
      overviewMap: undefined,
      attributesTableVisible: false,
      drawInteraction: null,
      modifyInteraction: null,
      translateInteraction: null,
      copiedFeatures: [],
      editedLayer: null,
      editModeLayer: null,
      editedLayers: {},
      currentMapResolution: 0,
      editingObject: false,
      objectGeometry: null,
      editedObjects: null,
      reportSelection: {
        drawInteraction: undefined,
        layer: undefined,
      },
      copyOfFeaturesBeingEdited: null,
      featuresBeingTranslated: [],
      featurePopupOverlay: null,
      featureDropdownOverlay: null,
      multipleFeaturePopupOverlay: null,
      mismatchApplicationVisible: false,
      attributeTableHeight: 50,
      measurementTools: {
        enabled: false,
        layer: null,
        drawInteraction: null,
        measureTooltipElement: null,
        measureTooltip: null,
        sketch: null,
      },
      mismatchMode: {
        drawLayer: null,
        drawInteraction: null,
      },
      searchMode: {
        drawLayer: null,
        drawInteraction: null,
      },
      setFeatureGeometryMode: {
        drawLayer: null,
        drawInteraction: null,
      },
      poleAnalysis: {
        layer: null,
        geometryLength: null,
        drawInteraction: null,
        modifyInteraction: null,
        waitingForResponse: false,
      },
      connectionAnalysis: {
        layer: null,
        modifyInteraction: null,
      },
      manyVerticesEditMode: {
        launched: false,
        vertexSource: null,
        vertexLayer: null,
        mergedVerticesLayer: null,
        selectInteraction: null,
        translateInteraction: null,
        feature: null,
      },
      fragmentCopy: {
        drawInteraction: null,
      },
      validationStyle: null,
      validationLayer: null,
      checkGeometry: null,
      getGeoErrorDetails: null,
      showGeoErrorOnMap: null,
      showGeoError: null,
      attributesTableReload: true,
      drawingStarted: false,
      initialView: {
        zoom: null,
        projection: null,
        center: null,
        resolution: null,
      },
      temporaryLayersExpanded: true,
      mapMounted: false,
      editLayerSelectedCollection: new Collection(),
      editModeInteraction: null,
      selectInteraction: null,
      hoverInteraction: null,
      snapInteractionsArr: [],
      zoomInteraction: null,

      requestNotification: false,
      objectDetailsRequest: false,
      currentZoom: null,
      tileLayersSnapSource: new VectorSource(),
      snapLayerIsUpdating: false,

      apiSessionCache: null,
      showCopyFeaturesModal: false,
      currentCacheHistory: [],
    };
  },
  computed: {
    ...mapGetters([
      'layers',
      'activeLayer',
      'tableMeta',
      'maxZIndex',
      'editSession',
      'manualImportMapTools',
      'coordinateSystem',
      'zoom',

      'resolution',
      'featuresTableActive',
      'featuresLayer',
      'searchPanelVisible',
      'manualImportPanelVisible',
      'visibleTemporaryLayers',
      'isSelectModePoint',
      'isSelectModePolygon',
      'isSelectModeRectangle',
      'poleAnalysisReady',
      'poleAnalysisWaitingForResponse',
      'roadLaneAnalysisStarted',
      'roadLaneAnalysisLayer',
      'roadLaneAnalysisModifyInteraction',
      'roadLaneAnalysisDrawingEnded',
      // 'editSessionType',
      'connectionAnalysisLaunched',
      'readOnly',
      'readOnlyVerified',
      'isHistoryDataMode',
      'setFeatureGeometryActive',
      'gettingFeatureInfo',
      'replaceGeometryInProgress',
      'featureToReplaceClone',
      'terytParcelSearchResultObject',
      'viewCenter',
      'forceResizablePanelExpand',
      'selectedMapFeatures',
      'features',
      'featuresColumns',
      'searchLayersItems',
      'demandFormVisible',
      'demandExportVisible',
      'reportDemandPopupVisible',
      'searchResultFilterVisible',
      'selectedSearchRadius',
      'selectedSearchByGeometryRadius',
      'searchSquareKmMax',
      'searchModuleByPoint',
      'searchModuleByRectangle',
      'searchModuleByPolygon',
      'searchResultsLoading',
      'manualImportfocusFeatureId',
      'manualImportSettings',
      'tileLayersFeatures',
      'zoomMode',
      'leftResizablePanelExpanded',
      'rightResizablePanelExpanded',
      'isMobileDevice',
      'isMobileVersion',
      'historyTimelineActive',
      'activeLayerGeometryColumns',
      'layersGeometryColumns',
      'isModifyMenuVisible',
    ]),
    ...mapGetters({
      selectedFeaturesRawData: 'selectedFeatures',
    }),
    featuresArr() {
      return JSON.parse(JSON.stringify(this.features));
    },
    selectedFeatures() {
      if (!this.editedActiveLayer) return [];
      // needed to recompute this variable
      const _watchers = [this.selectedFeaturesRawData];
      const activeLayerFeatures = this.editedActiveLayer
        .getSource()
        .getFeatures();
      return activeLayerFeatures.filter((feature) => feature.get('selected'));
    },
    isImportMode() {
      return (
        this.$store.getters.dataFeedId != null &&
        this.$store.getters.dataFeedType != null
      );
    },
    // showObjectGeometry() {
    //   return this.editedActiveLayer != null;
    // },
    editModeLayerHidden() {
      return (
        this.editedActiveLayer == null ||
        (this.editedActiveLayer != null && this.highMapResoulution)
      );
    },
    hideEditModeOverlay() {
      return (
        this.editedActiveLayer == null ||
        (this.editedActiveLayer != null && !this.highMapResoulution)
      );
    },
    highMapResoulution() {
      return this.currentMapResolution >= 10;
    },

    showSetFeatureGeometryTool() {
      return this.editedActiveLayer !== null && this.setFeatureGeometryActive;
    },
    getTogglerMargin() {
      if (this.featuresTableActive && this.$refs.map) {
        var containerHeight = this.$refs.map.clientHeight;
        var attributeTableHeight =
          (this.attributeTableHeight / 100) * containerHeight;
        var marginInPix = (containerHeight - attributeTableHeight) / 2;
        var marginInEm = marginInPix * 0.063;

        return marginInEm;
      }
      return 0;
    },
    toolbarVisible() {
      return this.$store.getters.toolsFetched && this.readOnlyVerified;
    },
    anyToolActivated() {
      return (
        this.searchPanelVisible ||
        this.mismatchApplicationVisible ||
        // this.showObjectGeometry ||
        this.poleAnalysisReady ||
        this.roadLaneAnalysisStarted ||
        this.connectionAnalysisLaunched ||
        this.isHistoryDataMode ||
        this.manualImportPanelVisible
      );
    },
    hasPermissionDataHistory() {
      return this.hasPermission('Data_history');
    },
    searchModeByGeometryDisabled() {
      return (
        !this.searchModuleByPoint &&
        !this.searchModuleByRectangle &&
        !this.searchModuleByPolygon
      );
    },
    editedActiveLayer: {
      get() {
        return this.activeLayer && this.editedLayers[this.activeLayer.id];
      },
      set(newValue) {
        this.editedLayers = {
          ...this.editedLayers,
          [this.activeLayer.id]: newValue,
        };
      },
    },
    activeLayerType() {
      return this.activeLayer && this.activeLayer.type;
    },
    editedLayerZIndex() {
      const standard = this.maxZIndex + 1;
      const active = standard + 1000;
      return {
        standard,
        active,
      };
    },
    canUseCache() {
      return this.$context.hasPermission('Add_infrastructure_data_from_files');
    },
  },
  watch: {
    activeLayer: {
      handler(newValue, oldValue) {
        const removeAllSelectionsFromLayer = (layerId) => {
          const layer = this.editedLayers[layerId];
          if (!layer) return;
          const features = layer.getSource().getFeatures();
          features.forEach(async (feature) => {
            await this.editFeatureSelectedInArr(feature, false);
            feature.set('selected', false, true);
          });
        };
        if (this.selectInteraction) {
          this.selectInteraction.getFeatures().clear();
          this.map.removeInteraction(this.selectInteraction);
        }

        if (oldValue) {
          removeAllSelectionsFromLayer(oldValue.id);
        }
        if (newValue) {
          removeAllSelectionsFromLayer(newValue.id);
        }

        if (newValue && oldValue && newValue.id !== oldValue.id) {
          this.startEditMode();
        }

        this.redrawActiveFeatures(oldValue);
      },
    },
    manualImportSettings: {
      deep: true,
      handler(newValue, oldValue) {
        this.tileLayersSnapSourceUpdate();
        this.updateSnapRange();
      },
    },
    // tileLayersFeatures: {
    //   deep: true,
    //   handler(newValue, oldValue) {
    //     this.tileLayersSnapSourceUpdate();
    //   }
    // },
    featuresArr: {
      deep: true,
      handler(newValue, oldValue) {
        this.UpdateEditLayer(newValue, oldValue);

        this.$nextTick().then(() => {
          if (this.editedActiveLayer) {
            this.updateSessionCache();
          }
        });
      },
    },
    layers(newValue, oldValue) {
      if (!oldValue.length && newValue) {
        this.loadCache();
      }
    },
    editSession: {
      handler(newValue, oldValue) {
        function changeVisibleHandler(event) {
          this.tileLayersSnapSourceUpdate();
        }
        if (newValue == true) {
          if (this.mismatchApplicationVisible) {
            this.toggleMismatchApplicationVisibility();
          }
          this.startEditMode();
          this.tileLayersSnapSourceUpdate();
          this.map.on('rendercomplete', (event) => {
            this.tileLayersSnapSourceUpdate();
          });
          // this.layers.forEach(layer => {
          //   if (
          //     this.manualImportSettings.snapLayers.find(snapLayer => {
          //       return snapLayer.id === layer.id;
          //     })
          //   ) {
          //     layer.mapLayer.on('change:visible', event => {
          //       this.tileLayersSnapSourceUpdate();
          //     });
          //   }
          // });
        } else {
          this.endEditMode();
          // this.layers.forEach(layer => {
          //   if (
          //     this.manualImportSettings.snapLayers.find(snapLayer => {
          //       return snapLayer.id === layer.id;
          //     })
          //   ) {
          //     layer.mapLayer.un('change:visible', event => {
          //       this.tileLayersSnapSourceUpdate();
          //     });
          //   }
          // });
        }
      },
    },
    manualImportfocusFeatureId: {
      handler(featureId) {
        if (featureId) {
          const feature = this.getFeatureFromEditedLayers(featureId);

          if (feature) {
            const mapView = this.map.getView();
            const geometry = feature.getGeometry();
            mapView.fit(geometry, {
              padding: [
                0,
                this.mapInset.right,
                this.mapInset.bottom,
                this.mapInset.left,
              ],
              minResolution: 1,
            });
          }
          this.$store.dispatch(RESET_FOCUSED_FEATURE_ID);
        }
      },
    },
    zoomMode(newValue, oldVale) {
      if (newValue) {
        this.endEditInteraction();
        this.zoomInteraction = new DragZoom({
          condition: always,
        });
        this.map.addInteraction(this.zoomInteraction);
      } else {
        if (this.zoomInteraction) {
          this.map.removeInteraction(this.zoomInteraction);
          this.zoomInteraction = null;
        }
      }
    },
    currentMapResolution(currentValue) {
      if (this.editedActiveLayer !== null) {
        if (currentValue >= 30) {
        }
      }
    },
    visibleTemporaryLayers(newValue, oldValue) {
      if (oldValue.length) {
        oldValue
          .map((ov) => ov.mapLayer)
          .forEach((ml) => this.map.removeLayer(ml));
      }

      newValue.map((nv) => nv.mapLayer).forEach((ml) => this.map.addLayer(ml));

      if (newValue.length) {
        const lastObject = newValue[newValue.length - 1];
        if (lastObject.metadata && !lastObject.zoomed) {
          this.map.getView().fit(lastObject.extent, this.map.getSize());
          lastObject.zoomed = true;
        }
      }
    },
    readOnlyVerified(value) {
      if (this.$store.getters.readOnly) {
        this.$notify({
          type: 'warn',
          title: 'Uwaga.',
          text: this.$store.getters.readOnlyMessage,
          duration: -1000,
        });
      }
    },
    anyToolActivated(value) {
      this.$store.commit(LEFT_RESIZABLE_PANEL_EXPAND_CHANGE, value);
    },

    hasPermissionDataHistory(value) {
      if (this.isHistoryDataMode && !value) {
        if (this.$refs.historicalData) {
          this.$refs.historicalData.reset();
        }
        this.$store.commit(MAP_HISTORY_DATA_MODE_SET, false);
      }
    },
    searchModuleByPoint: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          this.searchModeStartDraw('point');
        }
      },
    },
    searchModuleByRectangle: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          this.searchModeStartDraw('rectangle');
        }
      },
    },
    searchModuleByPolygon: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          this.searchModeStartDraw('polygon');
        }
      },
    },
    searchModeByGeometryDisabled: {
      handler(newValue) {
        if (
          !this.searchModuleByPoint &&
          !this.searchModuleByRectangle &&
          !this.searchModuleByPolygon
        ) {
          this.map.removeInteraction(this.searchMode.drawInteraction);
        }
      },
    },
    searchPanelVisible: {
      handler(newValue) {
        if (!newValue) {
          this.$store.commit(SEARCH_MODE_BY_GEOMETRY_DISABLE, null);
          this.map.removeInteraction(this.searchMode.drawInteraction);
          this.map.removeLayer(this.searchMode.drawLayer);
          this.searchMode.drawLayer = null;
          this.$store.commit(SET_FEATURES_WITH_COORDINATES, []);
          this.$store.commit(SEARCH_PANEL_SET_ITEMS, []);
          this.$store.getters.userGroupLayers.forEach((layer) => {
            if (layer.title == 'Warstwa wyszukiwarki') {
              this.$store.dispatch(TEMPORARY_LAYER_REMOVE, layer);
            }
          });
        }
      },
    },
  },
  methods: {
    /**
     * Returns a collection of all features from the edited layers.
     *
     * @returns {Collection<Feature>} A collection of unique features.
     */
    getAllFeaturesCollection() {
      return new Collection(
        Object.values(this.editedLayers).flatMap((layer) =>
          layer.getSource().getFeatures()
        ),
        { unique: true }
      );
    },
    getZaleznosciMapsForLayer(layerId) {
      return this.getGeometryDependenciesForLayer(layerId)
        .map(({ id, zaleznosci }) => {
          if (zaleznosci) {
            return {
              id,
              map: new Map(zaleznosci.map((single) => [single.id, single])),
            };
          }
          return null;
        })
        .filter(Boolean);
    },
    getGeometryDependenciesForLayer(layerId) {
      const id = layerId;
      return this.tableMeta.filter(
        (meta) =>
          meta.id === id ||
          (meta.zaleznosci &&
            meta.zaleznosci.some(
              ({ parent_layer_id, field }) =>
                parent_layer_id === id && field === '__geometry__'
            ))
      );
    },
    copyFeaturesToLayer(targetLayerId) {
      const targetLayer = this.layers.find(
        (layer) => layer.id === targetLayerId
      );
      if (!targetLayer) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: `Nie znaleziono danych dla warstwy o id ${targetLayerId}`,
          type: 'error',
          title: 'Uwaga.',
        });
        return;
      }

      try {
        const featuresToCopy = this.selectedFeatures.map((feature) => {
          const clonedFeature = feature.clone();
          clonedFeature.setProperties({});
          return clonedFeature;
        });
        this.$store.dispatch(ACTIVATE_LAYER, targetLayer);
        featuresToCopy.forEach((feature) => {
          this.addNewFeatureToArr(feature, { layer: targetLayerId });
        });
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'success',
          title: 'Sukces',
          message: 'Proces kopiowania przebiegł pomyślnie.',
        });
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error,
          type: 'error',
          title: 'Uwaga.',
        });
      } finally {
        this.showCopyFeaturesModal = false;
      }
    },
    handleEditedData() {
      const activeTool = Object.keys(this.manualImportMapTools).find(
        (key) => this.manualImportMapTools[key] === true
      );
      switch (activeTool) {
        case 'add': {
          return this.startAddFeatureDraw();
        }
        case 'edit': {
          return this.startEditFeatureDraw();
        }
        case 'delete': {
          return this.startDeleteDraw();
        }
        default: {
          return;
        }
      }
    },
    redrawActiveFeatures(oldActiveLayer) {
      const { standard, active } = this.editedLayerZIndex;

      if (this.editedActiveLayer) {
        this.editedActiveLayer.setStyle(this.getFeatureStyling(true));
        this.editedActiveLayer.setZIndex(active);
      }

      if (oldActiveLayer && this.editedLayers[oldActiveLayer.id]) {
        this.editedLayers[oldActiveLayer.id].setStyle(this.getFeatureStyling());
        this.editedLayers[oldActiveLayer.id].setZIndex(standard);
      }
    },
    getDependantFeaturesForFeature(feature, visited = new Set()) {
      // Check if the feature has already been processed
      if (visited.has(feature)) {
        return new Collection(); // Return an empty collection if already visited
      }

      visited.add(feature); // Mark the feature as visited
      const collection = new Collection();
      collection.push(feature);

      const properties = feature.getProperties();

      // Fetch dependency maps for the feature's layer
      this.getZaleznosciMapsForLayer(feature.get('layer')).forEach(
        ({ id, map }) => {
          map.forEach((value) => {
            if (value.field === '__geometry__') {
              const dependantFeature = this.getDependantFeature(
                id,
                value,
                map,
                properties
              );

              if (dependantFeature && !visited.has(dependantFeature)) {
                // Recursively fetch dependencies for the dependant feature
                const dependantCollection = this.getDependantFeaturesForFeature(
                  dependantFeature,
                  visited
                );

                // Merge the recursive results into the current collection
                dependantCollection.getArray().forEach((dep) => {
                  if (!collection.getArray().includes(dep)) {
                    collection.push(dep);
                  }
                });

                // Add the current dependant feature if not already added
                if (!collection.getArray().includes(dependantFeature)) {
                  collection.push(dependantFeature);
                }
              }
            }
          });
        }
      );

      return collection;
    },
    getDependantCollectionsForActiveLayer() {
      const features = this.editedActiveLayer.getSource().getFeatures();
      const collectionsArr = [];

      features.forEach((feature) => {
        const collection = this.getDependantFeaturesForFeature(feature);
        collectionsArr.push(collection);
      });

      return collectionsArr;
    },
    parseDependency(dependency) {
      if (!dependency) return null;

      // Check for "if" type dependencies
      if (dependency.startsWith('if:')) {
        const regex = /^if:(\w+)>__geometry__\^(\w+)$/;
        const match = dependency.match(regex);

        if (match) {
          return {
            conditional: true,
            depId: match[1], // Field name (e.g., "pe02")
            geometry: match[2], // Geometry type (e.g., "end")
          };
        }
      }

      // Check for "equals" type dependencies
      if (dependency.startsWith('equals||')) {
        return {
          equals: true,
        };
      }

      // If neither condition matches
      return null;
    },
    getDependantFeature(layerId, dependency, dependenciesMap, featureProps) {
      const { conditional, depId } = this.parseDependency(
        dependency.dependency
      );

      if (conditional) {
        return this.getDependantFeature(
          layerId,
          dependenciesMap.get(depId),
          dependenciesMap,
          featureProps
        );
      }

      const { field, parent_field, parent_layer_id } = dependency;
      const isActiveLayerDependencies = featureProps.layer === layerId;

      if (isActiveLayerDependencies) {
        if (!featureProps[field]) return null;

        const parentLayer = this.editedLayers[parent_layer_id];
        if (parentLayer) {
          const parentFeatures = parentLayer.getSource().getFeatures();
          const parentFeature = parentFeatures.find((feature) => {
            const value = feature.get(parent_field);
            return value === featureProps[field];
          });

          return parentFeature;
        }
      } else {
        if (!featureProps[parent_field]) return null;

        const childLayer = this.editedLayers[layerId];
        if (childLayer) {
          const childFeatures = childLayer.getSource().getFeatures();
          const childFeature = childFeatures.find((feature) => {
            const value = feature.get(field);

            return value === featureProps[parent_field];
          });

          return childFeature;
        }
      }

      return null;
    },
    updateSessionCache() {
      const editedLayersJsonObject = Object.entries(this.editedLayers).reduce(
        (acc, item) => {
          const [id, layer] = item;
          if (layer) {
            const features = layer.getSource().getFeatures();
            const geoJsonObject = new GeoJSON().writeFeaturesObject(features);

            return {...acc, [id]: geoJsonObject};
          }
        },
        {}
      );
      if (editedLayersJsonObject) {
        const lastSteps = this.currentCacheHistory.slice(
          0,
          numberOfStepsInHistory - 1
        );
        this.currentCacheHistory = [editedLayersJsonObject, ...lastSteps];
        if (this.canUseCache) {
          this.apiSessionCache.updateCache({
            history: [editedLayersJsonObject, ...lastSteps],
          });
        }
      }
    },
    async loadCache() {
      if (this.canUseCache) {
        try {
          const res = await this.apiSessionCache.getCache();
          this.currentCacheHistory = res.body.history
            ? res.body.history
            : [res.body];
          const { created, ...layers } = res.body.history
            ? res.body.history[0]
            : res.body;
          this.loadLayers(layers);
        } catch (e) {
          console.error(e);
        }
      }
    },
    loadLayers(layers) {
      const featuresProperties = [];
      const loadedEditedLayers = Object.entries(layers).reduce(
        (acc, [id, geoJsonObject]) => {
          if (!geoJsonObject.features.length) {
            return acc;
          }
          const features = new GeoJSON().readFeatures(geoJsonObject);
          featuresProperties.push(
            ...features.map((feature) => {
              feature.set('selected', false);
              return feature.getProperties();
            })
          );
          const layer = this.createEditVectorLayer(id);
          this.map.addLayer(layer);
          return { ...acc, [id]: layer };
        },
        {}
      );
      this.$store.commit(FEATURES_SET, featuresProperties);
      this.editedLayers = loadedEditedLayers;
    },
    getEditedLayerByFeatureId(featureId) {
      return Object.values(this.editedLayers).find((layer) =>
        Boolean(layer.getSource().getFeatureById(featureId))
      );
    },
    getFeatureFromEditedLayers(featureId) {
      const feature = this.getEditedLayerByFeatureId(featureId)

        if (feature === undefined) {
          return;
        }

        return feature.getSource()
        .getFeatureById(featureId);
    },
    leftPanelResized(value) {
      this.mapInset.left = value.width;
    },
    rightPanelResized(value) {
      this.mapInset.right = value.width;
    },
    bottomPanelResized(value) {
      this.mapInset.bottom = value.height;
    },
    leftPanelExpandUpdate(value) {
      this.$store.commit(LEFT_RESIZABLE_PANEL_EXPAND_CHANGE, value);
    },
    rightPanelExpandUpdate(value) {
      this.$store.commit(RIGHT_RESIZABLE_PANEL_EXPAND_CHANGE, value);
    },
    applyFilterToMap(filterCriteria) {
      this.filterCriteria = filterCriteria;
    },
    onCompositionPanelToggled(args) {
      this.$store.commit(COMPOSITION_LAYERS_EXPANDED_SET, args.expanded);
      if (this.$store.getters.compositionLayersExpanded) {
        this.temporaryLayersExpanded = false;
      } else if (args.isCompositionClick) {
        this.$refs.legend.$refs.tablist.scrollTop = 0;
      }
    },
    tileLayersSnapSourceUpdate() {
      // if (!this.snapLayerIsUpdating) {
      //   this.snapLayerIsUpdating = true;
      this.tileLayersSnapSource.clear();
      this.manualImportSettings.snapLayers.forEach((snapLayer) => {
        const layer = this.layers.find((l) => l.id == snapLayer.id);
        if (
          this.tileLayersFeatures[snapLayer.id] &&
          snapLayer.snap &&
          layer.visible
        ) {
          const tileLayerFeatures = this.tileLayersFeatures[snapLayer.id];
          tileLayerFeatures.forEach((feature) => {
            let geometry;
            const type = feature.type_;
            const inflatedCoordinates = inflateCoordinatesArray(
              feature.flatCoordinates_,
              0,
              feature.getEnds(),
              2
            );

            switch (type) {
              case 'Point':
                geometry = new Point(feature.flatCoordinates_);
                break;
              case 'LineString':
                geometry = new LineString(inflatedCoordinates[0]);
                break;
              case 'Polygon':
                geometry = new Polygon(inflatedCoordinates);
                break;
              case 'MultiLineString':
                geometry = new MultiLineString(inflatedCoordinates);
                break;
              case 'MultiPolygon':
                geometry = new MultiPolygon(inflatedCoordinates);
                break;
              default:
                break;
            }

            if (geometry) {
              const feature = new Feature({
                geometry: geometry,
              });
              this.tileLayersSnapSource.addFeature(feature);
            }
          });
        }
        // this.snapLayerIsUpdating = false;
      });
      // }
    },
    initSelectInteraction() {
      this.selectInteraction = new Select({
        layers: [this.editedActiveLayer],
        pixelTolerance: this.manualImportSettings.snapRange,
        condition: (e) => {
          if (!this.manualImportMapTools.select) return false;
          return singleClick(e);
        },
      });

      this.selectInteraction.on('select', (event) => {
        const selected = event.selected;
        const deselected = event.deselected;
        if (selected && selected.length) {
          selected.forEach(async (feature) => {
            await this.editFeatureSelectedInArr(feature, true);
          });
        }
        if (deselected && deselected.length) {
          deselected.forEach(async (feature) => {
            await this.editFeatureSelectedInArr(feature, false);
          });
        }
      });

      this.map.addInteraction(this.selectInteraction);
    },
    startSelectFeatureDraw() {
      this.endEditInteraction();

      this.editModeInteraction = new Select({
        layers: [this.editedActiveLayer],
        condition: pointerMove,
        pixelTolerance: this.manualImportSettings.snapRange,
      });

      this.map.addInteraction(this.editModeInteraction);
      this.$store.commit(MANUAL_IMPORT_MAP_TOOLS_SET, 'select');
    },
    async editFeatureSelectedInArr(editedFeature, value) {
      const editedFeatureId = editedFeature.id_;
      const feature = this.featuresArr.find((feature) => {
        return feature.id === editedFeatureId;
      });
      await this.$store.dispatch(EDIT_SESSION_EDIT_FEATURE, {
        ...feature,
        ...{ selected: value },
      });
    },
    getFeaturesAtCoordinates(coords, layerId) {
      if (layerId)
        return this.editedLayers[layerId]
          .getSource()
          .getFeaturesAtCoordinate(coords);

      const features = Object.values(this.editedLayers).reduce((arr, layer) => {
        return [...arr, ...layer.getSource().getFeaturesAtCoordinate(coords)];
      }, []);
      return features;
    },
    async updatedRelatedFeaturesOnAdd(addEvent, newFeatureId) {
      const getDependantFeatures = () => {
        const [_activeLayer, ...layers] = this.getGeometryDependenciesForLayer(
          this.activeLayer.id
        );
        const dependantFeatures = (layers || []).map((layer) => layer.id);

        const pixel = addEvent.target.downPx_;
        return this.map.getFeaturesAtPixel(pixel, {
          layerFilter: (layer) => dependantFeatures.includes(layer.get('id')),
        });
      };

      const validateFeatures = (features) => {
        if (
          features.length === 1 &&
          features[0].getGeometry().getType() === 'LineString'
        ) {
          return features[0];
        }

        // Other scenarios are not supported yet
        return undefined;
      };

      const arePointsEqual = (point1, point2) => {
        return point1[0] === point2[0] && point1[1] === point2[1];
      };

      const splitLineString = (lineGeometry, point) => {
        const closestPoint = lineGeometry.getClosestPoint(point);
        const coordinates = lineGeometry.getCoordinates();

        // Check for special cases: closestPoint at the beginning or end of the line
        if (arePointsEqual(closestPoint, coordinates[0])) {
          // Point at the start: Do not split
          return [lineGeometry, null];
        }

        if (arePointsEqual(closestPoint, coordinates[coordinates.length - 1])) {
          // Point at the end: Do not split
          return [lineGeometry, null];
        }

        let index = -1;
        let minDistance = Infinity;

        // Find the segment containing the closest point
        for (let i = 0; i < coordinates.length - 1; i++) {
          const segmentStart = coordinates[i];
          const segmentEnd = coordinates[i + 1];

          const segmentLine = new LineString([segmentStart, segmentEnd]);
          const closestOnSegment = segmentLine.getClosestPoint(point);

          const dist = getDistance(closestOnSegment, point);
          if (dist < minDistance) {
            minDistance = dist;
            index = i;
          }
        }

        // Split the line
        const part1 = coordinates.slice(0, index + 1);
        const part2 = coordinates.slice(index + 1);

        // Add closestPoint to part1 and part2 only if it's not already at the ends
        if (!arePointsEqual(part1[part1.length - 1], closestPoint)) {
          part1.push(closestPoint);
        }

        if (!arePointsEqual(part2[0], closestPoint)) {
          part2.unshift(closestPoint);
        }

        return [new LineString(part1), new LineString(part2)];
      };

      const getDependencyFieldsForFeature = (feature, relatedFeature) => {
        const featureLayerId = feature.get('layer');
        const relatedLayerId = relatedFeature.get('layer');
        const [zaleznosci] = this.getZaleznosciMapsForLayer(featureLayerId);
        const fulfilledDeps = [];
        const unfulFilledDeps = [];
        if (zaleznosci && zaleznosci.id === featureLayerId) {
          zaleznosci.map.forEach((value) => {
            const { equals } = this.parseDependency(value.dependency);
            if (
              equals &&
              feature.get(value.field) &&
              value.parent_layer_id === relatedLayerId
            ) {
              if (
                feature.get(value.field) ===
                relatedFeature.get(value.parent_field)
              ) {
                fulfilledDeps.push(value);
              } else {
                unfulFilledDeps.push(value);
              }
            }
          });

          return { fulfilledDeps, unfulFilledDeps };
        }
      };

      const modifyParams = (feature, isStartLine) => {
        const coords = feature.getGeometry().getCoordinates();
        const features = this.getFeaturesAtCoordinates(
          coords[isStartLine ? 0 : coords.length - 1]
        );
        const filteredFeatures = features.filter(
          (f) => f.get('layer') !== feature.get('layer')
        );
        const relatedFeature = filteredFeatures[0];
        if (!relatedFeature) return;
        const { unfulFilledDeps } = getDependencyFieldsForFeature(
          feature,
          relatedFeature
        );
        unfulFilledDeps.forEach((dependency) =>
          feature.set(dependency.field, newFeatureId)
        );
      };

      const updateFeature = async (feature) => {
        const newFeatureGeometry = await this.$store.dispatch(
          EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY,
          { geometry: feature.getGeometry().getCoordinates(), feature }
        );

        if (feature.get('id')) {
          await this.$store.dispatch(EDIT_SESSION_EDIT_FEATURE, {
            ...feature.getProperties(),
            ...newFeatureGeometry,
          });
        } else {
          await this.$store.dispatch(EDIT_SESSION_ADD_FEATURE, {
            ...feature.getProperties(),
            ...newFeatureGeometry,
          });
        }
      };

      const replaceLineString = async (originalLine, newLines) => {
        const [line1, line2] = newLines;

        if (!line2) return; // If no split occurred, do nothing

        originalLine.setGeometry(line1);
        const secondLine = originalLine.clone();
        secondLine.setGeometry(line2);
        secondLine.set('id', undefined);
        modifyParams(originalLine, true);
        modifyParams(secondLine, false);

        return Promise.all([
          updateFeature(originalLine),
          updateFeature(secondLine),
        ]);
      };

      const newFeature = addEvent.feature;
      const dependantFeatures = getDependantFeatures();
      const feature = validateFeatures(dependantFeatures);
      if (!feature) return;
      const newLines = splitLineString(
        feature.getGeometry(),
        newFeature.getGeometry().getCoordinates()
      );
      await replaceLineString(feature, newLines);
      return wasModified;
    },
    generateFeatureIdForLayer(layerId) {
      const layerIdToCompare = layerId || this.activeLayer.id;
      let prefix = '';
      const idColumn = this.tableMeta.find(
        (meta) => meta.id === layerIdToCompare
      ).kolumny[0].nazwa;

      if (idColumn) {
        const match = idColumn.match(/^([a-z]+)/);

        if (match) {
          prefix = match[1].toUpperCase();
        }
      }

      return generateFeatureId(prefix);
    },
    startAddFeatureDraw() {
      // Helper to determine the drawing type
      const getDrawType = () => {
        return {
          point: 'Point',
          linestring: 'LineString',
          polygon: 'Polygon',
        }[this.activeLayer.type];
      };

      // Helper to initialize and add the Draw interaction
      const addDrawInteraction = () => {
        const drawType = getDrawType();

        const idColumn = this.tableMeta.find(
          (meta) => meta.id === this.activeLayer.id
        ).kolumny[0].nazwa;

        this.editModeInteraction = new Draw({
          type: drawType,
          snapTolerance: this.manualImportSettings.snapRange, // Adjust this value as needed
        });

        if (this.editModeInteraction) {
          this.editModeInteraction.on('drawend', async (event) => {
            const newFeature = event.feature;
            const tmpId = this.generateFeatureIdForLayer();
            const extra = { [idColumn]: tmpId };

            await this.addNewFeatureToArr(newFeature, extra);
            if (drawType === 'Point') {
              // only lines scenario is supported currently
              await this.updateRelatedLine(event, tmpId);
            }
            this.addSnappingInteractions(); // needed to snap to newly created features
          });

          this.map.addInteraction(this.editModeInteraction);
        }
      };

      // Main logic
      this.endEditInteraction();
      addDrawInteraction();
      this.addSnappingInteractions();
      this.$store.commit(MANUAL_IMPORT_MAP_TOOLS_SET, 'add');
    },
    async updateRelatedLine(addFeatureEvent, newFeatureId) {
      const checkIfPointIsAddedToLine = (event) => {
        const [_activeLayer, ...layers] = this.getGeometryDependenciesForLayer(
          this.activeLayer.id
        );
        const dependantFeatures = (layers || []).map((layer) => layer.id);

        const pixel = event.target.downPx_;
        const features = this.map.getFeaturesAtPixel(pixel, {
          layerFilter: (layer) => dependantFeatures.includes(layer.get('id')),
        });

        if (
          features.length === 1 &&
          features[0].getGeometry().getType() === 'LineString'
        ) {
          return features[0];
        }

        // Other scenarios are not supported yet
        return undefined;
      };

      const arePointsEqual = (point1, point2) => {
        return point1[0] === point2[0] && point1[1] === point2[1];
      };

      const splitLineString = (lineGeometry, point) => {
        const closestPoint = lineGeometry.getClosestPoint(point);
        const coordinates = lineGeometry.getCoordinates();

        // Check for special cases: closestPoint at the beginning or end of the line
        if (arePointsEqual(closestPoint, coordinates[0])) {
          // Point at the start: Do not split
          return { variant: 'start', newLines: [lineGeometry] };
        }

        if (arePointsEqual(closestPoint, coordinates[coordinates.length - 1])) {
          // Point at the end: Do not split
          return { variant: 'end', newLines: [lineGeometry] };
        }

        let index = -1;
        let minDistance = Infinity;

        // Find the segment containing the closest point
        for (let i = 0; i < coordinates.length - 1; i++) {
          const segmentStart = coordinates[i];
          const segmentEnd = coordinates[i + 1];

          const segmentLine = new LineString([segmentStart, segmentEnd]);
          const closestOnSegment = segmentLine.getClosestPoint(point);

          const dist = getDistance(closestOnSegment, point);
          if (dist < minDistance) {
            minDistance = dist;
            index = i;
          }
        }

        // Split the line
        const part1 = coordinates.slice(0, index + 1);
        const part2 = coordinates.slice(index + 1);

        // Add closestPoint to part1 and part2 only if it's not already at the ends
        if (!arePointsEqual(part1[part1.length - 1], closestPoint)) {
          part1.push(closestPoint);
        }

        if (!arePointsEqual(part2[0], closestPoint)) {
          part2.unshift(closestPoint);
        }

        return {
          variant: 'standard',
          newLines: [new LineString(part1), new LineString(part2)],
        };
      };

      const updateLineAttributes = async (
        feature,
        startId,
        endId,
        createNew
      ) => {
        const newFeatureGeometry = await this.$store.dispatch(
          EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY,
          { geometry: feature.getGeometry().getCoordinates(), feature }
        );
        feature.set('lk02_id_punktu_poczatkowego', startId);
        feature.set('lk04_id_punktu_koncowego', endId);

        if (createNew) {
          await this.$store.dispatch(EDIT_SESSION_ADD_FEATURE, {
            ...feature.getProperties(),
            ...newFeatureGeometry,
          });
        } else {
          await this.$store.dispatch(EDIT_SESSION_EDIT_FEATURE, {
            ...lineToBeModified.getProperties(),
            ...newFeatureGeometry,
          });
        }
      };

      const newFeature = addFeatureEvent.feature;
      const lineToBeModified = checkIfPointIsAddedToLine(addFeatureEvent);
      if (!lineToBeModified) return;

      const originalLineGeometry = lineToBeModified.getGeometry();
      const { variant, newLines } = splitLineString(
        originalLineGeometry,
        newFeature.getGeometry().getCoordinates()
      );

      const [line1, line2] = newLines;
      lineToBeModified.setGeometry(line1);
      const lineStart = lineToBeModified.get('lk02_id_punktu_poczatkowego');
      const lineEnd = lineToBeModified.get('lk04_id_punktu_koncowego');
      const secondLine = lineToBeModified.clone();

      // Update attributes for the first line
      if (variant === 'start') {
        await updateLineAttributes(
          lineToBeModified,
          newFeatureId,
          lineStart,
          false
        );
      } else {
        await updateLineAttributes(
          lineToBeModified,
          lineStart,
          newFeatureId,
          false
        );
      }

      if (line2) {
        // Create a new line for the second part
        secondLine.setGeometry(line2);
        secondLine.set('id', undefined); // Clear ID for the new feature
        secondLine.set(
          'lk01_id_lk',
          this.generateFeatureIdForLayer(lineToBeModified.get('layer'))
        );
        await updateLineAttributes(secondLine, newFeatureId, lineEnd, true);
      }
    },
    addSnappingInteractions() {
      // Snap to features collection
      const featureSnap = new Snap({
        features: this.getAllFeaturesCollection(),
        pixelTolerance: this.manualImportSettings.snapRange,
      });
      this.map.addInteraction(featureSnap);
      this.snapInteractionsArr.push(featureSnap);

      // Snap to tile layer sources
      const tileLayerSnap = new Snap({
        source: this.tileLayersSnapSource,
        pixelTolerance: this.manualImportSettings.snapRange,
      });
      this.map.addInteraction(tileLayerSnap);
      this.snapInteractionsArr.push(tileLayerSnap);
    },
    startEditFeatureDraw() {
      // Helper to add the Modify interaction
      const addModifyInteractions = () => {
        const collections = this.getDependantCollectionsForActiveLayer();

        const interactions = collections.map((collection) => {
          const featureFromActiveLayer = collection.getArray()[0];
          return new Modify({
            features: collection,
            insertVertexCondition: never,
            pixelTolerance: this.manualImportSettings.snapRange,
            condition: (e) => {
              const features = this.map.getFeaturesAtPixel(e.pixel_);
              if (features.includes(featureFromActiveLayer))
                return primaryAction(e);
              return false;
            },
          });
        });

        interactions.forEach((interaction) => {
          interaction.on('modifyend', (event) => {
            this.editFeaturesGeometryInArr(event.features.array_);
          });

          this.map.addInteraction(interaction);
        });

        this.editModeInteraction = interactions;
      };

      // Main logic
      this.endEditInteraction();
      addModifyInteractions();
      this.addSnappingInteractions();
      this.$store.commit(MANUAL_IMPORT_MAP_TOOLS_SET, 'edit');
    },
    async editFeaturesGeometryInArr(editedFeatures) {
      const updatedFeaturesPromises = editedFeatures.map(
        async (editedFeature) => {
          const editedFeatureId = editedFeature.id_;
          const coordinates = editedFeature.getGeometry().getCoordinates();
          const feature = this.featuresArr.find((feature) => {
            return feature.id === editedFeatureId;
          });
          const newFeatureGeometry = await this.$store.dispatch(
            EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY,
            { geometry: coordinates, feature: editedFeature }
          );

          return {
            ...feature,
            ...newFeatureGeometry,
          };
        }
      );

      const updatedFeatures = await Promise.all(updatedFeaturesPromises);

      await this.$store.dispatch(EDIT_SESSION_EDIT_FEATURES, updatedFeatures);
    },
    startDeleteDraw() {
      this.endEditInteraction();
      const editModeSource = this.editedActiveLayer.getSource();

      this.editModeInteraction = new Select({
        layers: [this.editedActiveLayer],
        condition: singleClick,
      });

      this.editModeInteraction.on('select', (event) => {
        if (event.selected && event.selected.length > 0) {
          this.deleteFeatureFromArr(event.selected[0].id_);
        }

        this.editModeInteraction.getFeatures().clear();
      });

      this.hoverInteraction = new Select({
        layers: [this.editedActiveLayer],
        condition: pointerMove,
      });

      this.map.addInteraction(this.editModeInteraction);
      this.map.addInteraction(this.hoverInteraction);

      // Initialize the Snap interaction
      const snapInteraction = new Snap({
        source: editModeSource,
        pixelTolerance: this.manualImportSettings.snapRange, // Adjust this value as needed
        edge: true,
        vertex: true,
        vertexPixelTolerance: this.manualImportSettings.snapRange,
        snapToVertex: true,
        snapToEdge: true,
      });

      this.snapInteractionsArr.push(snapInteraction);
      this.snapInteractionsArr.forEach((snapInteraction) => {
        this.map.addInteraction(snapInteraction);
      });
      this.$store.commit(MANUAL_IMPORT_MAP_TOOLS_SET, 'delete');
    },
    deleteFeatureFromArr(featureId) {
      this.$store.dispatch(EDIT_SESSION_DELETE_FEATURE, featureId);
    },
    endEditInteraction() {
      this.$store.commit(MANUAL_IMPORT_MAP_TOOLS_SET, null);
      if (this.editModeInteraction) {
        const interactions = Array.isArray(this.editModeInteraction)
          ? this.editModeInteraction
          : [this.editModeInteraction];
        interactions.forEach((interaction) => {
          this.map.removeInteraction(interaction);
        });
        this.editModeInteraction = null;
      }
      if (this.hoverInteraction) {
        this.map.removeInteraction(this.hoverInteraction);
        this.hoverInteraction = null;
      }
      if (this.snapInteractionsArr) {
        this.snapInteractionsArr.forEach((snapInteraction) => {
          this.map.removeInteraction(snapInteraction);
        });
        this.snapInteractionsArr = [];
      }
      if (this.zoomInteraction) {
        this.$store.commit(MAP_ZOOM_MODE_TOGGLE);
      }
    },
    updateSnapRange() {
      if (this.editModeInteraction) {
        this.editModeInteraction.snapTolerance_ =
          this.manualImportSettings.snapRange;
        this.editModeInteraction.pixelTolerance_ =
          this.manualImportSettings.snapRange;
      }
      if (this.selectInteraction) {
        this.selectInteraction.snapTolerance_ =
          this.manualImportSettings.snapRange;
        this.selectInteraction.pixelTolerance_ =
          this.manualImportSettings.snapRange;
      }
      if (this.hoverInteraction) {
        this.hoverInteraction.snapTolerance_ =
          this.manualImportSettings.snapRange;
        this.hoverInteraction.pixelTolerance_ =
          this.manualImportSettings.snapRange;
      }
      if (this.snapInteractionsArr) {
        this.snapInteractionsArr.forEach((snapInteraction) => {
          snapInteraction.snapTolerance_ = this.manualImportSettings.snapRange;
          snapInteraction.pixelTolerance_ = this.manualImportSettings.snapRange;
        });
      }
    },
    moveBack() {
      this.$store.dispatch(MAP_PREVIOUS_VIEW_MOVE, this.map);
    },
    moveForward() {
      this.$store.dispatch(MAP_NEXT_VIEW_MOVE, this.map);
    },
    setCentre(args) {
      let center = transform(
        [args.x, args.y],
        args.coordinateSystem,
        'EPSG:2180'
      );
      this.map.getView().setCenter(center);
    },
    async publishDemand(demand) {
      await this.$store.dispatch(PUBLISH_DEMAND, demand);
    },
    async exportDemand(target) {
      await this.$store.dispatch(EXPORT_DEMAND, target);
    },
    setRange(args) {
      let leftBottom = transform(
        args.leftBottom,
        args.coordinateSystem,
        'EPSG:2180'
      );
      let rightTop = transform(
        args.rightTop,
        args.coordinateSystem,
        'EPSG:2180'
      );
      this.map.getView().fit(leftBottom.concat(rightTop), this.map.getSize());
    },
    setExtent(extent) {
      if (extent) {
        const transformedExtent = transform(
          extent,
          this.coordinateSystem,
          'EPSG:2180'
        );
        this.map.getView().fit(transformedExtent, this.map.getSize());
      }
    },
    showFullRange() {
      this.map.getView().setCenter(this.initialView.center);
      this.map.getView().setZoom(this.initialView.zoom);
    },
    showOverviewMap() {
      this.overviewMap.setCollapsed(!this.overviewMap.getCollapsed());
    },
    setZoom(zoom) {
      if (this.map) {
        this.map.getView().setZoom(zoom);
      }
    },
    setResolution(resolution) {
      if (this.map) {
        this.map.getView().setResolution(resolution);
      }
    },
    setCoordinateSystem(previous, current) {
      const customFormat = 'X: {x}, Y: {y}';
      const EPSG4326Format = 'Dł: {x}, Szer: {y}';
      this.mousePositionControl.setProjection(current);
      this.mousePositionControl.setCoordinateFormat((coords) =>
        format(
          coords,
          current === 'EPSG:4326' ? EPSG4326Format : customFormat,
          current === 'EPSG:4326' ? 8 : 2
        )
      );
    },
    showAttributesTable() {
      this.attributesTableVisible = true;
    },
    showZoomTool(value, zoomClass) {
      let showClass = 'showZoom';
      let zoomElement = $(zoomClass);
      if (value) {
        zoomElement.addClass(showClass);
      } else {
        zoomElement.removeClass(showClass);
      }
    },
    getFeatureStyling(isActive) {
      const stroke = new Stroke({
        color: isActive ? '#ffa500' : '#319fd3',
        width: 2.5,
      });
      const fill = new Fill({ color: 'rgba(255, 255, 255, 0.6)' });
      const style = new Style({
        image: new CircleStyle({
          fill,
          stroke,
          radius: 10,
        }),
        stroke,
      });
      return style;
    },
    createEditVectorLayer(layerId, source) {
      if (!source) source = new VectorSource();
      const style = this.getFeatureStyling(Boolean(this.activeLayer));
      const layer = new VectorLayer({
        source,
        zIndex: this.editedLayerZIndex.standard,
        style,
        properties: {
          id: layerId,
        },
      });

      return layer;
    },
    startEditMode() {
      if (!this.editedActiveLayer) {
        this.editedActiveLayer = this.createEditVectorLayer(
          this.activeLayer.id
        );

        this.map.addLayer(this.editedActiveLayer);
        this.editedActiveLayer.getSource().clear();
      }

      this.endEditInteraction();
      this.initSelectInteraction();
    },
    endEditMode() {
      this.map.removeLayer(this.editedActiveLayer);
      this.editedLayers = {};
      this.editedObjects = null;

      this.updateSessionCache();
      this.endEditInteraction();
    },
    UpdateFeaturesData() {
      // switch (this.activeLayer.type) {
      //       case 'point':
    },
    UpdateEditLayer(featuresArrNew, featuresArrOld) {
      const getColumns = (feature) => {
        if (feature.layer)
          return (
            (this.layersGeometryColumns[feature.layer] &&
              this.layersGeometryColumns[feature.layer].column) ||
            []
          );
        return (
          (this.activeLayerGeometryColumns &&
            this.activeLayerGeometryColumns.column) ||
          []
        );
      };

      featuresArrOld.forEach(async (oldFeature) => {
        const columns = getColumns(oldFeature);

        const newFeature = featuresArrNew.find(
          (newFeature) => newFeature.id === oldFeature.id
        );

        if (!newFeature) {
          //delete features
          this.deleteFeature(oldFeature.id);
        } else {
          //modify features
          // change feature gometry
          switch (columns.length) {
            case 1:
              if (oldFeature[columns[0]] != newFeature[columns[0]]) {
                this.modifyFeatureGeometryOnMap(newFeature);
              }
              break;
            case 2:
              if (
                oldFeature[columns[0]] != newFeature[columns[0]] ||
                oldFeature[columns[1]] != newFeature[columns[1]]
              ) {
                this.modifyFeatureGeometryOnMap(newFeature);
              }
              break;
          }
          // change feature visibility
          if (
            this.selectInteraction &&
            oldFeature.selected != newFeature.selected
          ) {
            this.modifyFeatureSelectedOnMap(newFeature);
          }
          if (oldFeature.visible != newFeature.visible) {
            this.modifyFeatureVisibilityOnMap(newFeature);
          }
          // change feature select
        }
      });

      featuresArrNew.forEach(async (newFeature) => {
        const oldFeature = featuresArrOld.find(
          (oldFeature) => oldFeature.id === newFeature.id
        );

        if (!oldFeature) {
          //Add new features
          this.addNewFeatureOnMap(
            (await this.$store.dispatch(
              EDIT_SESSION_GET_FEATURE_GEOMETRY,
              newFeature
            )) || null,
            newFeature
          );
        }

        const { geometry, ...properties } = newFeature;
        const featureOnMap = this.getFeatureFromEditedLayers(newFeature.id);
        if (featureOnMap) {
          featureOnMap.setProperties(properties);
        }
      });
    },

    addNewFeatureOnMap(featurePoints, featureProperties) {
      const { id, layer } = featureProperties;
      const layerMeta =
        this.layers.find(({ id }) => id === layer) || this.activeLayer;
      if (layer !== undefined) {
        let newFeature = null;
        switch (layerMeta.type) {
          case 'point':
            newFeature = new Feature(
              featurePoints
                ? new Point(featurePoints)
                : new Point([-999999999999, -999999999999])
            );

            // return newFeature.getId();
            break;
          case 'linestring':
            newFeature = new Feature(
              featurePoints ? new LineString(featurePoints) : new LineString([])
            );

            // return newFeature.getId();
            break;
          case 'polygon':
            newFeature = new Feature(
              featurePoints ? new Polygon(featurePoints) : new Polygon([])
            );

            // return newFeature.getId();
            break;
        }
        this.editedLayers[layer].getSource().addFeature(newFeature);
        id ? newFeature.setId(id) : newFeature.setId(getUid(newFeature));
      }
    },
    updateRelatedFeatures(impactedFeatures) {
      const featuresFromSameLayer = Map.groupBy(
        impactedFeatures,
        ({ layer }) => layer
      );

      featuresFromSameLayer.forEach(async (layer) => {
        const [firstFeature, ...otherFeatures] = layer;
        if (!firstFeature) return;
        const coordinates = layer
          .reduce((acc, { feature }) => {
            const featureCoords = feature.getGeometry().getCoordinates();
            return [...acc, ...featureCoords];
          }, [])
          .filter((coord, i, arr) => {
            const coordsString = coord.join();
            const prevItem = arr[i - 1];

            return !(prevItem && prevItem.join() === coordsString);
          });
        const newFeatureGeometry = await this.$store.dispatch(
          EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY,
          { geometry: coordinates, feature: firstFeature.feature }
        );
        const firstFeatureMeta = this.featuresArr.find((feature) => {
          return feature.id === firstFeature.feature.id_;
        });
        const updateFeatureProps = {
          [firstFeature.field]: '',
        };

        if (otherFeatures) {
          otherFeatures.forEach(({ feature }) => {
            updateFeatureProps[firstFeature.field] = feature.get(
              firstFeature.field
            );
            this.deleteFeatureFromArr(feature.id_);
          });
        }
        this.$store.dispatch(EDIT_SESSION_EDIT_FEATURE, {
          ...firstFeatureMeta,
          ...newFeatureGeometry,
          ...updateFeatureProps,
        });
      });
    },
    deleteFeature(featureId) {
      const layer = this.getEditedLayerByFeatureId(featureId);
      if (layer) {
        const feature = layer.getSource().getFeatureById(featureId);
        if (!feature) {
          return;
        }
      } else {
        return;
      }

      const featureDependencies = this.getDependantFeaturesForFeature(feature);
      const impactedFeatures = [];
      featureDependencies.forEach((dependantFeature) => {
        if (dependantFeature === feature) {
          return;
        }

        const zaleznosci = this.getZaleznosciMapsForLayer(
          dependantFeature.get('layer')
        );

        zaleznosci.forEach((z) => {
          z.map.forEach((value) => {
            if (
              value.field !== '__geometry__' &&
              dependantFeature.get(value.field) &&
              dependantFeature.get(value.field) ===
                feature.get(value.parent_field)
            ) {
              impactedFeatures.push({
                feature: dependantFeature,
                field: value.field,
                layer: z.id,
              });
            }
          });
        });
      });

      this.updateRelatedFeatures(impactedFeatures);
      this.deleteFeatureFromMap(layer, feature);
    },
    deleteFeatureFromMap(layer, feature) {
      layer.getSource().removeFeature(feature);
    },
    async modifyFeatureGeometryOnMap(feature) {
      const featureId = feature.id;
      const newGeometry = await this.$store.dispatch(
        EDIT_SESSION_GET_FEATURE_GEOMETRY,
        feature
      );

      const featureToModify = this.getFeatureFromEditedLayers(featureId);
      switch (this.activeLayer.type) {
        case 'point':
          featureToModify
            .getGeometry()
            .setCoordinates(newGeometry || [-999999999999, -999999999999]);

          break;
        case 'linestring':
          featureToModify.getGeometry().setCoordinates(newGeometry || []);

          break;
        case 'polygon':
          featureToModify.getGeometry().setCoordinates(newGeometry || []);

          break;
      }
    },
    modifyFeatureVisibilityOnMap(featureToChange) {
      const featureToToggleVisibility = this.getFeatureFromEditedLayers(
        featureToChange.id
      );
      const transparentStyle = new Style({
        fill: new Fill({
          color: 'rgba(0, 0, 0, 0)', // Transparent fill color
        }),
        stroke: new Stroke({
          color: 'rgba(0, 0, 0, 0)', // Transparent stroke color
        }),
      });
      featureToChange.visible
        ? featureToToggleVisibility.setStyle(null)
        : featureToToggleVisibility.setStyle(transparentStyle);
    },
    modifyFeatureSelectedOnMap(featureToChange) {
      const featureToToggleSelected = this.getFeatureFromEditedLayers(
        featureToChange.id
      );

      if (featureToChange.selected) {
        this.selectInteraction.getFeatures().push(featureToToggleSelected);
      } else {
        this.selectInteraction.getFeatures().remove(featureToToggleSelected);
      }
    },
    async addNewFeatureToArr(feature, extra) {
      const coordinates = feature.getGeometry().getCoordinates();
      const newFeature = await this.$store.dispatch(
        EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY,
        coordinates
      );
      await this.$store.dispatch(EDIT_SESSION_ADD_FEATURE, {
        ...newFeature,
        ...(extra || {}),
      });
    },

    async copyFeature() {
      this.showCopyFeaturesModal = true;
    },
    async removeFeature(permanently) {},
    async onAddFeature(evt) {},

    onTranslateStart(evt) {
      const self = this;
      const featuresBeingTranslated = evt.features.getArray();
      self.validationLayer.getSource().clear();

      featuresBeingTranslated.forEach((fbt) => {
        const clonedFeature = fbt.clone();
        clonedFeature.setId(fbt.getId());
        self.featuresBeingTranslated.push(clonedFeature);
      });
    },
    async onTranslateFeature(evt) {},
    onManyVerticesTranslationStart() {},
    afterEnter() {
      this.map.updateSize();
    },
    async onValidationReportObjectChoosen(objectId, isGeoError) {},
    onValidationReportErrorClicked(choosenObj) {
      if (
        !choosenObj.isGeo &&
        choosenObj.columns &&
        choosenObj.columns.length > 0 &&
        this.$refs['attributes-table']
      ) {
        const column = choosenObj.columns[0];
        this.$refs['attributes-table'].scrollToColumn(column);
      }
    },
    onAddressSearchObjectChoosen(searchObject) {
      if (searchObject.y != null && searchObject.x != null) {
        const fill = new Fill({
          color: 'rgba(255,255,255,0.4)',
        });
        const stroke = new Stroke({
          color: '#cad700',
          width: 1.5,
        });
        const customStyle = new Style({
          image: new CircleStyle({
            fill: fill,
            stroke: stroke,
            radius: 9,
          }),
          fill: fill,
          stroke: stroke,
          zIndex: 9999,
        });

        const point = new Point([
          parseFloat(searchObject.x),
          parseFloat(searchObject.y),
        ]).transform('EPSG:2180', this.$store.getters.coordinateSystem);
        const feature = new Feature(point);
        feature.setStyle(customStyle);
        const source = new VectorSource();
        source.addFeature(feature);
        //Radius around point
        if (this.selectedSearchRadius) {
          const radiusFill = new Fill({
            color: 'rgba(255,50,255,0.2)',
          });
          const radiusStroke = new Stroke({
            color: '#cad700',
            width: 1.5,
          });
          const radiusCustomStyle = new Style({
            image: new CircleStyle({
              fill: radiusFill,
              stroke: radiusStroke,
              radius: 9,
            }),
            fill: radiusFill,
            stroke: radiusStroke,
            zIndex: 9999,
          });
          const centerPoint = new Point([
            parseFloat(searchObject.x),
            parseFloat(searchObject.y),
          ]).transform('EPSG:2180', this.$store.getters.coordinateSystem);

          const radiusInMapUnits = this.selectedSearchRadius * 1000;

          const circleGeometry = new Circle(
            centerPoint.getCoordinates(),
            radiusInMapUnits
          );

          // Create a circle feature using the geometry and set its style
          const circleFeature = new Feature(circleGeometry);
          circleFeature.setStyle(radiusCustomStyle);

          // Add the circleFeature to the source
          source.addFeature(circleFeature);
        }

        const layer = {
          title: 'Warstwa wyszukiwarki',
          visible: true,
          search: true,
          mapLayer: new VectorLayer({ source: source, zIndex: Infinity }),
        };
        this.$store.dispatch(SEARCH_LAYER_ADD_OR_EDIT, layer);
        this.map.getView().fit(point.getExtent(), { maxZoom: 14 });
      } else {
        // nie znaleziono wyników
        // const feature = new Feature();
        // const source = new VectorSource({
        //   crossOrigin: 'anonymous'
        // });
        // source.addFeature(feature);
        // const layer = {
        //   title: 'Warstwa wyszukiwarki',
        //   visible: true,
        //   search: true,
        //   mapLayer: new VectorLayer({ source: source, zIndex: Infinity })
        // };
        // this.$store.dispatch(SEARCH_LAYER_ADD_OR_EDIT, layer);
        // this.$notify({
        //   type: 'error',
        //   title: 'Uwaga!',
        //   text: 'Wystąpił błąd podczas wyszukiwania adresu.',
        //   duration: 2000
        // });
      }
    },
    async onFeaturesFound(featuresWithCoordinates) {
      const featuresCoordinates = featuresWithCoordinates.map(
        (feature) => feature.geometry.coordinates
      );
      const fill = new Fill({
        color: 'rgba(0,0,139,0.4)',
      });
      const stroke = new Stroke({
        color: '#cad700',
        width: 1.5,
      });
      const customStyle = new Style({
        image: new CircleStyle({
          fill: fill,
          stroke: stroke,
          radius: 9,
        }),
        fill: fill,
        stroke: stroke,
        zIndex: 9999,
      });

      const source = new VectorSource();

      await featuresCoordinates.forEach((pointCoords) => {
        const point = new Point(pointCoords).transform(
          'EPSG:2180',
          this.$store.getters.coordinateSystem
        );
        const feature = new Feature(point);
        feature.setStyle(customStyle);
        source.addFeature(feature);
      });
      if (this.searchMode.drawLayer) {
        this.map.removeLayer(this.searchMode.drawLayer);
      }

      this.searchMode.drawLayer = null;
      // source.getFeatures().forEach(el => {
      // });
      this.searchMode.drawLayer = new VectorLayer({
        source: source,
        zIndex: Infinity,
      });

      this.map.addLayer(this.searchMode.drawLayer);
    },
    searchModeStartDraw(type) {
      switch (type) {
        case 'point':
          (() => {
            this.map.removeInteraction(this.searchMode.drawInteraction);
            this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
              type: 'info',
              title: 'Informacja',
              message: `Proszę zaznaczyć punkt na mapie.`,
              duration: 5000,
            });
            let fillColor = 'rgba(255,50,255,0.2)';
            let strokeColor = 'rgba(202,215,0)';

            let drawStyle = new Style({
              fill: new Fill({
                color: fillColor,
              }),
              stroke: new Stroke({
                color: strokeColor,
                width: 3,
              }),
            });
            this.searchMode.drawInteraction = new Draw({
              type: 'Point',
              style: drawStyle,
            });
            this.map.addInteraction(this.searchMode.drawInteraction);

            this.searchMode.drawInteraction.on('drawend', async (event) => {
              await this.$store.commit(SEARCH_ADDRESS_SET_SELECTED_OBJECT, {});
              const fill = new Fill({
                color: 'rgba(255,255,255,0.4)',
              });
              const stroke = new Stroke({
                color: '#cad700',
                width: 1.5,
              });
              const customStyle = new Style({
                image: new CircleStyle({
                  fill: fill,
                  stroke: stroke,
                  radius: 9,
                }),
                fill: fill,
                stroke: stroke,
                zIndex: 9999,
              });

              const drawnFeature = event.feature;
              drawnFeature.setStyle(customStyle);
              const source = new VectorSource();
              source.addFeature(drawnFeature);

              if (this.selectedSearchByGeometryRadius) {
                const featureCoordinates = event.feature
                  .getGeometry()
                  .getCoordinates();
                const radiusFill = new Fill({
                  color: 'rgba(255,50,255,0.2)',
                });
                const radiusStroke = new Stroke({
                  color: '#cad700',
                  width: 1.5,
                });
                const radiusCustomStyle = new Style({
                  image: new CircleStyle({
                    fill: radiusFill,
                    stroke: radiusStroke,
                    radius: 9,
                  }),
                  fill: radiusFill,
                  stroke: radiusStroke,
                  zIndex: 9999,
                });
                const centerPoint = new Point(featureCoordinates).transform(
                  'EPSG:2180',
                  this.$store.getters.coordinateSystem
                );

                const radiusInMapUnits =
                  this.selectedSearchByGeometryRadius * 1000;

                const circleGeometry = new Circle(
                  centerPoint.getCoordinates(),
                  radiusInMapUnits
                );

                // Create a circle feature using the geometry and set its style
                const circleFeature = new Feature(circleGeometry);
                circleFeature.setStyle(radiusCustomStyle);

                // Add the circleFeature to the source
                source.addFeature(circleFeature);
              }

              const layer = {
                title: 'Warstwa wyszukiwarki',
                visible: true,
                search: true,
                mapLayer: new VectorLayer({
                  source: source,
                  zIndex: Infinity,
                }),
              };
              this.$store.dispatch(SEARCH_LAYER_ADD_OR_EDIT, layer);
              const point = {
                x: drawnFeature.getGeometry().getCoordinates()[0],
                y: drawnFeature.getGeometry().getCoordinates()[1],
              };
              this.$store.dispatch(SEARCH_OBJECTS_WFS_GET, {
                context: this,
                point,
                radius: this.selectedSearchByGeometryRadius,
              });

              this.map.removeInteraction(this.searchMode.drawInteraction);
              this.$store.commit(SEARCH_MODE_BY_GEOMETRY_DISABLE, null);
            });
          })();
          break;
        case 'rectangle':
          (() => {
            this.map.removeInteraction(this.searchMode.drawInteraction);
            this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
              type: 'info',
              title: 'Informacja',
              message: `Proszę zaznaczyć obszar na mapie.`,
              duration: 5000,
            });
            let fillColor = 'rgba(255,50,255,0.2)';
            let strokeColor = 'rgba(202,215,0)';

            let drawStyle = new Style({
              fill: new Fill({
                color: fillColor,
              }),
              stroke: new Stroke({
                color: strokeColor,
                width: 3,
              }),
            });

            this.searchMode.drawInteraction = new Draw({
              type: 'Circle',
              style: drawStyle,
              geometryFunction: createBox(),
            });

            this.map.addInteraction(this.searchMode.drawInteraction);
            this.searchMode.drawInteraction.on('drawend', async (event) => {
              await this.$store.commit(SEARCH_ADDRESS_SET_SELECTED_OBJECT, {});
              const source = new VectorSource();
              const layer = {
                title: 'Warstwa wyszukiwarki',
                visible: true,
                search: true,
                mapLayer: new VectorLayer({
                  source: source,
                  style: drawStyle,
                  zIndex: Infinity,
                }),
              };
              const drawnFeature = event.feature;
              source.addFeature(drawnFeature);
              const area = getArea(drawnFeature.getGeometry(), {
                projection: 'EPSG:2180',
              });
              const areaSquareKm = Math.round((area / 1000000) * 100) / 100;

              if (areaSquareKm <= this.searchSquareKmMax) {
                this.$store.dispatch(SEARCH_LAYER_ADD_OR_EDIT, layer);
                const polygon = drawnFeature.getGeometry().getCoordinates();

                this.$store.dispatch(SEARCH_OBJECTS_WFS_GET, {
                  context: this,
                  polygon: polygon,
                });
              } else {
                this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
                  type: 'warn',
                  title: 'Uwaga. Zaznaczono zbyt duży obszar',
                  message: `Wybrano za duży obszar, maksymalny obszar wyszukiwania to ${this.searchSquareKmMax}<span>km<sup>2</sup></span>.`,
                  duration: 5000,
                });
              }

              this.map.removeInteraction(this.searchMode.drawInteraction);
              this.$store.commit(SEARCH_MODE_BY_GEOMETRY_DISABLE, null);
            });
          })();

          break;
        case 'polygon':
          (() => {
            this.map.removeInteraction(this.searchMode.drawInteraction);
            this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
              type: 'info',
              title: 'Informacja',
              message: `Proszę zaznaczyć obszar na mapie.`,
              duration: 5000,
            });
            let fillColor = 'rgba(255,50,255,0.2)';
            let strokeColor = 'rgba(202,215,0)';

            let drawStyle = new Style({
              fill: new Fill({
                color: fillColor,
              }),
              stroke: new Stroke({
                color: strokeColor,
                width: 3,
              }),
            });

            this.searchMode.drawInteraction = new Draw({
              type: 'Polygon',
              style: drawStyle,
            });

            this.map.addInteraction(this.searchMode.drawInteraction);
            this.searchMode.drawInteraction.on('drawend', async (event) => {
              await this.$store.commit(SEARCH_ADDRESS_SET_SELECTED_OBJECT, {});
              const source = new VectorSource();
              const layer = {
                title: 'Warstwa wyszukiwarki',
                visible: true,
                search: true,
                mapLayer: new VectorLayer({
                  source: source,
                  style: drawStyle,
                  zIndex: Infinity,
                }),
              };
              const drawnFeature = event.feature;
              source.addFeature(drawnFeature);
              const area = getArea(drawnFeature.getGeometry(), {
                projection: 'EPSG:2180',
              });
              const areaSquareKm = Math.round((area / 1000000) * 100) / 100;

              if (areaSquareKm <= this.searchSquareKmMax) {
                this.$store.dispatch(SEARCH_LAYER_ADD_OR_EDIT, layer);
                const polygon = drawnFeature.getGeometry().getCoordinates();
                this.$store.dispatch(SEARCH_OBJECTS_WFS_GET, {
                  context: this,
                  polygon: polygon,
                });
              } else {
                this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
                  type: 'warn',
                  title: 'Uwaga. Zaznaczono zbyt duży obszar',
                  message: `Wybrano za duży obszar, maksymalny obszar wyszukiwania to ${this.searchSquareKmMax}<span>km<sup>2</sup></span>.`,
                  duration: 5000,
                });
              }

              this.map.removeInteraction(this.searchMode.drawInteraction);
              this.$store.commit(SEARCH_MODE_BY_GEOMETRY_DISABLE, null);
            });
          })();
          // this.$store.commit(SEARCH_MODE_BY_POLYGON_ENABLE, null);
          break;
        default:
          break;
      }
    },

    onMileageSearchObjectChoosen(searchObject) {
      if (searchObject.length > 0) {
        var features = this.getFeaturesForMileageSearch(searchObject);
        var layer = this.getLayerForMileageSearch();
        if (layer) {
          // warstwa istnieje - dodaje obiekty
          this.editLayerForMileageSearch(features);
        } else {
          // dodaje warstwe
          this.addLayerForMileageSearch(features);
        }
      } else {
        // nie znaleziono wyników
        this.$notify({
          type: 'error',
          title: 'Uwaga!',
          text: 'Brak wyników wyszukiwania kilometrażu dla podanych danych.',
          duration: 2000,
        });
      }
    },
    getFeaturesForMileageSearch(searchObject) {
      var features = searchObject.map((x) => {
        return new Feature(
          new Point([
            parseFloat(x.geometria_1992.coordinates[0]),
            parseFloat(x.geometria_1992.coordinates[1]),
          ]).transform('EPSG:2180', this.$store.getters.coordinateSystem)
        );
      });
      return features;
    },
    getLayerForMileageSearch() {
      return this.$store.getters.temporaryLayers.find(
        (x) => x.mileageSearch == true
      );
    },
    addLayerForMileageSearch(features) {
      var src = require('../assets/punkt_kolo_pom.png');
      var imgSize = 30;
      var img = this.getVectorImage(src, imgSize);
      var source = new VectorSource();
      source.addFeatures(features);
      var layer = {
        title: 'Warstwa wyszukiwarki - kilometraż',
        visible: true,
        mileageSearch: true,
        mapLayer: new VectorLayer({
          source: source,
          zIndex: Infinity,
          style: new Style({
            image: new Icon({
              img: img,
              imgSize: [imgSize, imgSize],
            }),
          }),
        }),
      };
      this.$store.dispatch(MILEAGE_SEARCH_LAYER_ADD, layer);
      this.map.getView().fit(source.getExtent(), {
        constrainResolution: false,
        maxZoom: 15.5,
      });
    },
    async editLayerForMileageSearch(features) {
      var updatedLayer = await this.$store.dispatch(
        MILEAGE_SEARCH_LAYER_APPEND_FEATURES,
        features
      );
      this.map.getView().fit(updatedLayer.mapLayer.getSource().getExtent(), {
        constrainResolution: false,
        maxZoom: 15.5,
      });
    },
    async onCoordinateSearchObjectChoosen(resultObject) {
      var self = this;
      if (resultObject && resultObject.result.length > 0) {
        self.deselectFeatures();
        let selectedFeatureObjs = [];
        var api = new LayersApi();
        for (var id of resultObject.result) {
          let obj = await api.getWarstwyWektoroweByLayerIdObiektyByFeatureId({
            wso2_id: this.contextEmail,
            orgid: this.contextOrganizationId,
            layer_id: this.featuresLayer.id,
            feature_id: id,
          });
          selectedFeatureObjs.push(obj.body);
        }
        self.$store.dispatch(MAP_SELECTION_APPLY, {
          selectedFeatureObjs: selectedFeatureObjs,
        });
        var point = new Point([
          parseFloat(resultObject.searchObject.X),
          parseFloat(resultObject.searchObject.Y),
        ]).transform(
          resultObject.searchObject.coordinateSystem,
          self.$store.getters.coordinateSystem
        );
        var pointExtent = point.getExtent();
        var extentBuffered = buffer(
          pointExtent,
          parseFloat(resultObject.searchObject.tolerance)
        );
        self.map.getView().fit(extentBuffered);
      } else {
        // nie znaleziono wyników
        self.$notify({
          type: 'error',
          title: 'Uwaga!',
          text: 'Brak wyników wyszukiwania za pomocą koordynatów dla podanych danych.',
          duration: 5000,
        });
      }
    },
    onTerytParcelSearchObjectChoosen(object) {
      var objects = [];
      object.searchObject.forEach((obj) => {
        obj = obj
          .toUpperCase()
          .replace('POLYGON', '')
          .replace('((', '')
          .replace('))', '');
        var objCoordinates = obj.split(',');
        var XYcoordinates = [];
        objCoordinates.forEach((item) => {
          var xy = item.split(' ');
          var coord = [];
          xy.forEach((x) => coord.push(parseFloat(x)));
          XYcoordinates.push(coord);
        });

        var searchParcel = {
          geom: { coordinates: [] },
          numer: object.parcelNumber ? object.parcelNumber.toString() : '',
        };
        searchParcel.geom.coordinates.push(XYcoordinates);
        objects.push(searchParcel);
      });
      this.onTerytSearchObjectChoosen(objects);
    },
    onTerytSearchObjectChoosen(searchObject) {
      if (searchObject.length > 0) {
        var features = this.getFeaturesForTerytSearch(searchObject);
        var style = this.getStyleForTerytSearch();
        var layer = this.getLayerForTerytSearch();
        if (layer) {
          // warstwa juz istnieje - usuwam warstwe
          this.$store.dispatch(TEMPORARY_LAYER_REMOVE, layer);
        } // warstwa nie istnieje lub zostala usunieta - tworze nowa
        this.addLayerForTerytSearch(features, style);
      } else {
        // nie znaleziono wyników
        this.$notify({
          type: 'error',
          title: 'Uwaga!',
          text: 'Brak wyników wyszukiwania działki dla podanych danych.',
          duration: 2000,
        });
      }
    },
    getFeaturesForTerytSearch(searchObject) {
      var features = [];
      searchObject.forEach((obj) => {
        var pol = new Polygon(obj.geom.coordinates);
        var polygon = pol.transform(
          'EPSG:2180',
          this.$store.getters.coordinateSystem
        );
        var feature = new Feature(polygon);
        feature.set('name', obj.numer);
        features.push(feature);
      });

      return features;
    },
    getStyleForTerytSearch() {
      return new Style({
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.6)',
        }),
        stroke: new Stroke({
          color: '#319FD3',
          width: 1,
        }),
        text: new Text({
          font: '12px Calibri,sans-serif',
          fill: new Fill({
            color: '#000',
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 3,
          }),
        }),
      });
    },
    getLayerForTerytSearch() {
      return this.$store.getters.temporaryLayers.find(
        (x) => x.terytSearch == true
      );
    },
    addLayerForTerytSearch(features, style) {
      var source = new VectorSource();
      source.addFeatures(features);
      var layer = {
        title: 'Warstwa wyszukiwarki - lokalizowanie obiektów',
        visible: true,
        terytSearch: true,
        mapLayer: new VectorLayer({
          source: source,
          style: function (feature) {
            style.getText().setText(feature.get('name'));
            return style;
          },
          zIndex: Infinity,
        }),
      };
      this.$store.dispatch(TERYT_SEARCH_LAYER_ADD, layer);
      this.map.getView().fit(source.getExtent(), {
        constrainResolution: false,
        maxZoom: 15.5,
      });
    },
    async editLayerForTerytSearch(features) {
      var updatedLayer = await this.$store.dispatch(
        TERYT_SEARCH_LAYER_APPEND_FEATURES,
        features
      );
      this.map.getView().fit(updatedLayer.mapLayer.getSource().getExtent(), {
        constrainResolution: false,
        maxZoom: 15.5,
      });
    },
    toggleSelectMode(mode) {
      if (this.editSession) {
        this.endEditInteraction();
        this.startSelectFeatureDraw();
      }
    },
    deselectFeatures() {
      this.$store.dispatch(MAP_SELECTION_CLEAR);
    },
    toggleMismatchApplicationVisibility() {
      if (this.mismatchApplicationVisible) {
        this.$refs.mismatch.cancel();
      }
      if (this.isMobileDevice) {
        if (
          this.mismatchApplicationVisible &&
          !this.leftResizablePanelExpanded
        ) {
          this.$store.commit(LEFT_RESIZABLE_PANEL_EXPAND_CHANGE, true);
        } else {
          this.mismatchApplicationVisible = !this.mismatchApplicationVisible;
        }
      } else {
        this.mismatchApplicationVisible = !this.mismatchApplicationVisible;
      }
    },
    getParamValueFromUrl(param) {
      var results = new RegExp('[?&]' + param + '=([^&#]*)').exec(
        window.location.href
      );
      if (results == null) {
        return null;
      } else {
        return decodeURI(results[1]) || 0;
      }
    },

    startMismatchInteraction(type) {
      this.endMismatchInteraction();
      let fillColor = 'rgba(255, 255, 255, 0.2)';
      let strokeColor = 'rgba(239, 212, 38, 1)';
      let drawLayerSource = new VectorSource({
        useSpatialIndex: false,
      });

      var src = require('../assets/punkt_kolo.png');
      var imgSize = 30;
      var img = this.getVectorImage(src, imgSize);

      this.mismatchMode.drawLayer = new VectorLayer({
        source: drawLayerSource,
        zIndex: Number.POSITIVE_INFINITY,
        style: new Style({
          fill: new Fill({
            color: fillColor,
          }),
          stroke: new Stroke({
            color: strokeColor,
            width: 2,
          }),
          image: new Icon({
            img: img,
            imgSize: [imgSize, imgSize],
          }),
        }),
      });

      let drawStyle = new Style({
        fill: new Fill({
          color: fillColor,
        }),
        stroke: new Stroke({
          color: strokeColor,
          width: 3,
        }),
      });

      this.mismatchMode.drawInteraction = new Draw({
        source: drawLayerSource,
        type: type,
        style: drawStyle,
      });

      this.map.addLayer(this.mismatchMode.drawLayer);
      this.map.addInteraction(this.mismatchMode.drawInteraction);

      this.mismatchMode.drawInteraction.on(
        'drawstart',
        function (event) {
          drawLayerSource.clear();
        },
        this
      );

      var self = this;
      this.mismatchMode.drawInteraction.on('drawend', function (event) {
        if (type === 'Point') {
          self.$store.commit(MISMATCH_POINT_SET, event.feature);
        } else if (type === 'Polygon') {
          self.$store.commit(MISMATCH_AREA_SET, event.feature);
        }
      });
    },
    getVectorImage(src, size) {
      var canvas = document.createElement('canvas');
      canvas.setAttribute('width', size);
      canvas.setAttribute('height', size);
      var ctx = canvas.getContext('2d');
      var img = new Image();
      img.onload = function () {
        ctx.drawImage(img, 0, 0, size, size);
      };
      img.src = src;
      return canvas;
    },
    endMismatchInteraction() {
      if (
        this.mismatchMode.drawInteraction != null &&
        this.mismatchMode.drawLayer != null
      ) {
        this.map.removeInteraction(this.mismatchMode.drawInteraction);
        this.map.removeLayer(this.mismatchMode.drawLayer);
        this.mismatchMode.drawInteraction = null;
        this.mismatchMode.drawLayer = null;
      }
    },
    clearMismatchDrawInteractionSource() {
      if (this.mismatchMode.drawInteraction != null)
        this.mismatchMode.drawInteraction.source_.clear();
    },
    startSetFeatureGeometryInteraction() {
      this.$store.dispatch(BEGIN_SET_FEATURE_GEOMETRY, this.map);
    },
    endSetFeatureGeometryInteraction() {
      if (
        this.$store.getters.setFeatureGeometryLayer != null &&
        this.$store.getters.setFeatureGeometryDrawInteraction != null
      ) {
        this.map.removeInteraction(this.$store.getters.setFeatureGeometryLayer);
        this.map.removeLayer(
          this.$store.getters.setFeatureGeometryDrawInteraction
        );
      }
    },
    clearSetFeatureGeometryDrawInteractionSource() {
      if (this.setFeatureGeometryMode.drawInteraction != null)
        this.setFeatureGeometryMode.drawInteraction.source_.clear();
    },
    startPoleAnalysis() {
      const self = this;
      const poleAnalysisLayerSource = new VectorSource();
      poleAnalysisLayerSource.addFeature(
        this.$store.getters.poleAnalysisFeature
      );
      this.poleAnalysis.layer = new VectorLayer({
        source: poleAnalysisLayerSource,
      });

      this.poleAnalysis.modifyInteraction = new Modify({
        source: poleAnalysisLayerSource,
      });

      this.poleAnalysis.modifyInteraction.on('modifyend', (evt) => {
        const originalCoordinates = evt.mapBrowserEvent.coordinate;
        const lineCoordinates = evt.features
          .item(0)
          .getGeometry()
          .getCoordinates();
        const index = lineCoordinates.findIndex(
          (coord) =>
            coord[0] === originalCoordinates[0] &&
            coord[1] === originalCoordinates[1]
        );

        this.$store.dispatch(POINT_CHANGED, {
          index: index,
          coordinates: originalCoordinates,
        });
      });

      if (this.poleAnalysis.layer) {
        this.poleAnalysis.layer.setZIndex(Infinity);
      }

      this.map.addLayer(this.poleAnalysis.layer);

      this.$notify({
        type: 'info',
        title: 'Informacja.',
        text: 'Narysuj planowany przebieg inwestycji. Aby zakończyć wybierz dwukrotnie koniec linii.',
        duration: -1,
      });
    },
    stopPoleAnalysis() {
      this.map.removeInteraction(this.poleAnalysis.modifyInteraction);
      this.map.removeLayer(this.poleAnalysis.layer);

      this.$notify({ clean: true });
    },
    onPoleAnalysisDrawEnded() {
      this.map.addInteraction(this.poleAnalysis.modifyInteraction);
    },
    onRoadLaneAnalysisStarted() {
      this.map.addLayer(this.roadLaneAnalysisLayer);
    },
    onRoadLaneAnalysisDrawingEnded() {
      this.map.addInteraction(this.roadLaneAnalysisModifyInteraction);
    },
    onRoadLaneAnalysisEnded() {
      this.map.removeLayer(this.roadLaneAnalysisLayer);
      this.map.removeInteraction(this.roadLaneAnalysisModifyInteraction);
    },
    startConnectionAnalysis() {
      const self = this;
      const connectionAnalysisSource = new VectorSource();
      connectionAnalysisSource.addFeature(
        this.$store.getters.connectionAnalysisFeature
      );
      this.connectionAnalysis.layer = new VectorLayer({
        source: connectionAnalysisSource,
        zIndex: Infinity,
      });
      this.connectionAnalysis.modifyInteraction = new Modify({
        source: connectionAnalysisSource,
      });

      this.connectionAnalysis.modifyInteraction.on('modifyend', (evt) => {
        const originalCoordinates = evt.mapBrowserEvent.coordinate;
        const lineCoordinates = evt.features
          .item(0)
          .getGeometry()
          .getCoordinates();
        const index = lineCoordinates.findIndex(
          (coord) =>
            coord[0] === originalCoordinates[0] &&
            coord[1] === originalCoordinates[1]
        );
        this.$store.commit(CONNECTION_POINT_CHANGED, {
          index: index,
          coordinates: originalCoordinates,
        });
      });

      this.map.addLayer(this.connectionAnalysis.layer);

      this.$notify({
        type: 'info',
        title: 'Informacja.',
        text: 'Narysuj planowany przebieg inwestycji. Aby zakończyć wybierz dwukrotnie koniec linii.',
        duration: -1,
      });
    },
    onConnectionAnalysisDrawEnded() {
      this.map.addInteraction(this.connectionAnalysis.modifyInteraction);
    },
    stopConnectionAnalysis() {
      this.map.removeInteraction(this.connectionAnalysis.modifyInteraction);
      this.map.removeLayer(this.connectionAnalysis.layer);
      this.$notify({ clean: true });
    },
    copyFragment() {
      // if (!this.selectedMapFeatures.size) {
      //   this.$notify({
      //     type: 'info',
      //     title: 'Informacja.',
      //     text:
      //       'Przed rozpoczęciem kopiowania fragmentu obiektu należy go wybrać.',
      //     duration: 2000
      //   });
      //   return;
      // }
      // const self = this;
      // const converter = new jsts.io.OL3Parser();
      // const bladeSource = new VectorSource();
      // this.fragmentCopy.drawInteraction = new Draw({
      //   type: 'Polygon',
      //   source: bladeSource
      // });
      // if (this.isImportMode) {
      //   let fill = new Fill({ color: [255, 255, 255, 0.6] });
      //   let stroke = new Stroke({ color: [238, 238, 11, 1], width: 3 });
      //   this.fragmentCopy.drawInteraction = new Draw({
      //     type: 'Polygon',
      //     source: bladeSource,
      //     style: new Style({
      //       fill: fill,
      //       stroke: stroke,
      //       image: new CircleStyle({ fill, stroke, radius: 4 })
      //     })
      //   });
      // }
      // this.map.addInteraction(this.fragmentCopy.drawInteraction);
      // const featureToCopy = this.editLayerSelectedCollection.item(0);
      // const featureGeometry = featureToCopy.getGeometry().clone();
      // const geojsonFeatureGeometry = new GeoJSON().writeGeometryObject(
      //   featureGeometry
      // );
      // const geojsonReader = new jsts.io.GeoJSONReader();
      // const geomToCut = geojsonReader.read(geojsonFeatureGeometry);
      // const geojsonWriter = new jsts.io.GeoJSONWriter();
      // this.toggleSelectMode(MODE_NONE);
      // bladeSource.on('addfeature', function(e) {
      //   const addedFeatureGeometry = e.feature.getGeometry();
      //   const addedFeatureGeojsonGeometry = new GeoJSON().writeGeometryObject(
      //     addedFeatureGeometry
      //   );
      //   const blade = geojsonReader.read(addedFeatureGeojsonGeometry);
      //   if (blade.isValid()) {
      //     const cutGeomJsts = geomToCut.intersection(blade);
      //     const cutGeomJson = geojsonWriter.write(cutGeomJsts);
      //     const cutGeomOl = new GeoJSON().readGeometry(cutGeomJson);
      //     const fragmentFeature = new Feature(cutGeomOl);
      //     self.editModeLayer.getSource().addFeature(fragmentFeature);
      //   } else {
      //     self.$notify({
      //       type: 'error',
      //       title: 'Uwaga.',
      //       text:
      //         'Narysowany obiekt ma niepoprawną geometrię - linie nie mogą się przecinać. Proszę spróbować ponownie.',
      //       duration: 5000
      //     });
      //   }
      //   self.fragmentCopy.drawInteraction.setActive(false);
      //   self.toggleSelectMode(MODE_POINT);
      // });
    },
    updateSnapFeatures() {},
    showHistoricalData(askForConfirmation) {
      const self = this;

      if (!askForConfirmation) {
        this.resetHistoricData();
        return;
      }

      if (self.isHistoryDataMode) {
        let confirmationWindow = self.$refs.confirmationWindow;
        confirmationWindow.setMessage(
          'Czy na pewno chcesz powrócić do przeglądania danych aktualnych?'
        );
        confirmationWindow.setYesAction(function () {
          self.resetHistoricData();
        });
        confirmationWindow.setNoAction();
        confirmationWindow.show();
        return;
      } else {
        if (!self.featuresLayer) {
          self.$notify({
            type: 'warn',
            title: 'Uwaga.',
            text: 'Aby przeglądać dane historyczne, należy wybrać warstwę aktywną.',
            duration: 5000,
          });

          return;
        }

        self.$store.commit(MAP_HISTORY_DATA_MODE_SET, true);
      }
    },
    resetHistoricData() {
      this.$refs.historicalData.reset();
      this.$store.commit(MAP_HISTORY_DATA_MODE_SET, false);
    },
    setLowerHigher(value) {
      this.attributesTableReload = value;
    },

    showDecision(decision) {
      var format = new WKT();
      var feature = format.readFeature(decision.geometria_wkt, {
        dataProjection: 'EPSG:2180',
        featureProjection: 'EPSG:2180',
      });

      this.$store.dispatch(OTHER_TEMPORARY_LAYER_ADD, {
        title: `Decyzja numer ${decision.numer}`,
        mapLayer: new VectorLayer({
          source: new VectorSource({
            features: [feature],
          }),
          zIndex: Infinity,
        }),
      });
      this.map.getView().fit(buffer(feature.getGeometry().getExtent(), 100), {
        constrainResolution: false,
      });
    },
    useStoredSettings() {
      if (
        this.$store.getters.storedZoom !== undefined &&
        this.$store.getters.storedZoom !== null
      ) {
        this.$store.commit(MAP_ZOOM_SET, this.$store.getters.storedZoom);
      }

      if (
        this.$store.getters.storedResolution !== undefined &&
        this.$store.getters.storedResolution !== null
      ) {
        this.$store.commit(
          MAP_RESOLUTION_SET,
          this.$store.getters.storedResolution
        );
      }

      if (
        this.$store.getters.storedCenter !== undefined &&
        this.$store.getters.storedCenter !== null
      ) {
        this.$store.commit(VIEW_CENTER_SET, this.$store.getters.storedCenter);
      }

      this.$store.commit(
        SYSTEM_LAYERS_EXPANDED_SET,
        this.$store.getters.storedSystemLayersExpanded
      );
      this.$store.commit(
        MVT_LAYERS_EXPANDED_SET,
        this.$store.getters.storedMvtLayersExpanded
      );
      this.$store.commit(
        PWID_LAYERS_EXPANDED_SET,
        this.$store.getters.storedPwidLayersExpanded
      );

      this.$store.commit(
        ARCHIVE_LAYERS_EXPANDED_SET,
        this.$store.getters.storedArchiveLayersExpanded
      );
      this.$store.commit(
        USER_LAYERS_EXPANDED_SET,
        this.$store.getters.storedUserLayersExpanded
      );
      this.$store.commit(
        COMPOSITION_LAYERS_EXPANDED_SET,
        this.$store.getters.storedCompositionLayersExpanded
      );
      this.$store.commit(
        BACKGROUND_LAYERS_EXPANDED_SET,
        this.$store.getters.storedBackgroundLayersExpanded
      );
    },
    toggleRequestNotification() {
      this.requestNotification = !this.requestNotification;
      this.requestNotification
        ? this.map.addEventListener('click', this.handleMapClick)
        : this.map.removeEventListener('click', this.handleMapClick);

      if (!this.requestNotification) {
        this.hideMarkerClickMap();
      }
    },
    toggleObjectDetails() {
      this.objectDetailsRequest = !this.objectDetailsRequest;
      this.objectDetailsRequest
        ? this.map.addEventListener('click', this.handleObjectDetailsRequest)
        : this.map.removeEventListener(
            'click',
            this.handleObjectDetailsRequest
          );
    },
    handleObjectDetailsRequest(event) {
      const x = event.coordinate[0];
      const y = event.coordinate[1];
      const features = this.searchLayersItems[0].items;

      const calculateDistance = (x1, y1, x2, y2) => {
        return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
      };

      const MAX_DISTANCE = 10;

      let closestObject = null;
      let minDistance = Infinity;

      features.forEach((feature) => {
        const featureX = feature.coordinates[0];
        const featureY = feature.coordinates[1];
        const distance = calculateDistance(x, y, featureX, featureY);

        if (distance < minDistance && distance < MAX_DISTANCE) {
          minDistance = distance;
          closestObject = feature;
        }
      });

      if (closestObject) {
        this.$store.commit(DISPLAY_CLOSEST_OBJECT_INFO, closestObject);
      }
    },
    handleMapClick(event) {
      const coordinate = event.coordinate;

      const x = event.coordinate[0];
      const y = event.coordinate[1];

      this.showMarkerOnMap(x, y);
      this.centerMap(x, y);
      this.showPopup(x, y);
    },

    showPopup(x, y) {
      const coordinateSystem = this.extractEpsgNumber(
        this.$store.getters.coordinateSystem
      );
      this.getAddressByCoordinatesAndShowPopup(x, y, coordinateSystem);
    },

    extractEpsgNumber(coordinateSystem) {
      return parseInt(coordinateSystem.split(':')[1]);
    },

    async getAddressByCoordinatesAndShowPopup(x, y, coordinateSystem) {
      try {
        const api = new ZglaszaniePopytuApi();
        const response = await api.searchAddressByCoordinates(
          {
            body: {
              x,
              y,
              coordinateSystemCode: coordinateSystem,
            },
          },
          {
            ignoreGlobalError: true,
            download: false,
            withCredentials: false,
            hasContentType: false,
            jsonData: true,
          }
        );
        if (response) {
          this.$store.commit(REPORT_DEMAND_POPUP_SHOW, {
            ...response.body,
            x: response.body.x || x,
            y: response.body.y || y,
          });
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error,
          type: 'error',
          title:
            'Usługa wyszukiwania jest czasowo niedostępna. Spróbuj ponownie później',
        });
      }
    },

    showMarkerOnMap(x, y) {
      this.hideMarkerClickMap();
      var iconFeature = new Feature({
        geometry: new Point([x, y]),
        name: 'Miejsce kliknięcia',
      });

      var iconStyle = new Style({
        image: new Icon({
          src: 'data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGQ9Ik0yNTYsMEMxNjcuNjQxLDAsOTYsNzEuNjI1LDk2LDE2MGMwLDI0Ljc1LDUuNjI1LDQ4LjIxOSwxNS42NzIsNjkuMTI1QzExMi4yMzQsMjMwLjMxMywyNTYsNTEyLDI1Niw1MTJsMTQyLjU5NC0yNzkuMzc1ICAgQzQwOS43MTksMjEwLjg0NCw0MTYsMTg2LjE1Niw0MTYsMTYwQzQxNiw3MS42MjUsMzQ0LjM3NSwwLDI1NiwweiBNMjU2LDI1NmMtNTMuMDE2LDAtOTYtNDMtOTYtOTZzNDIuOTg0LTk2LDk2LTk2ICAgYzUzLDAsOTYsNDMsOTYsOTZTMzA5LDI1NiwyNTYsMjU2eiIgZmlsbD0iI0Q4MDAyNyIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=',
          scale: 0.05,
          anchor: [0.5, 1],
        }),
      });

      iconFeature.setStyle(iconStyle);
      const vectorSource = new VectorSource({
        features: [iconFeature],
      });
      const vectorLayer = new VectorLayer({
        source: vectorSource,
      });
      vectorLayer.set('name', 'Punkt');
      vectorLayer.setZIndex(9999);

      this.map.addLayer(vectorLayer);
    },

    hideMarkerClickMap() {
      this.map.getLayers().forEach((layer) => {
        if (layer.get('name') != undefined && layer.get('name') === 'Punkt') {
          this.map.removeLayer(layer);
        }
      });
    },

    centerMap(x, y) {
      let center = transform(
        [x, y],
        this.$store.getters.coordinateSystem,
        'EPSG:2180'
      );
      this.map.getView().setCenter(center);
    },
    // showOnMap() {
    //   if (this.selectedMapFeatures.size === 0) {
    //     return;
    //   }

    //   let selectedFeatures = this.$store.getters.features.filter(x =>
    //     this.selectedMapFeatures.has(x.id)
    //   );
    //   const getExtent = x =>
    //     x.extent
    //       ? x.extent
    //       : this.createMapFeature(x.geometry.coordinates, x.id, x.geometry.type)
    //           .getGeometry()
    //           .getExtent();
    //   const extent = createEmpty();
    //   selectedFeatures.forEach(x => {
    //     extend(extent, getExtent(x));
    //   });

    //   const minResolution = this.featuresLayer.mapLayer.getMinResolution();
    //   const maxResolution =
    //     this.featuresLayer.mapLayer.getMaxResolution() - 0.001;

    //   const extentToFit = buffer(extent, 100);

    //   this.map.getView().fit(extentToFit, {
    //     constrainResolution: false,
    //     minResolution:
    //       minResolution || (maxResolution > 0 ? Math.min(1, maxResolution) : 1)
    //   });

    //   const domMapSize = this.map.getSize();
    //   const center = getCenter(extentToFit);
    //   this.map
    //     .getView()
    //     .centerOn(center, domMapSize, [
    //       domMapSize[0] / 2 - 100,
    //       domMapSize[1] / 2 - 100
    //     ]);
    // }
    async getTableMeta() {
      try {
        const api = new ApiTableMeta();
        const response = await api.getTableMeta({
          wso2_id: encodeURIComponent(
            this.contextEmail || 'Użytkownik niezalogowany'
          ),
          orgid: this.contextOrganizationId,
          rodzaj: -1,
          allColumns: true,
        });
        if (response) {
          this.$store.commit(FEATURES_TABLE_META_SET, response.body.tables);
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error,
          type: 'error',
          title: 'Uwaga.',
        });
      }
    },
    async getDictionaries() {
      try {
        const api = new ApiSlowniki();
        const response = await api.getDictionaries({
          wso2_id: encodeURIComponent(
            this.contextEmail || 'Użytkownik niezalogowany'
          ),
          orgid: this.contextOrganizationId,
          page_number: 1,
          items_per_page: 1000,
          order_by: null,
          desc: null,
        });
        if (response) {
          this.$store.commit(
            FEATURES_DICTIONARIES_SET,
            response.body.dictionaries
          );
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error,
          type: 'error',
          title: 'Uwaga.',
        });
      }
    },
  },

  async mounted() {

    var self = this;
    this.apiSessionCache = new ApiSessionCache({
      wso2_id: this.contextEmail,
      orgid: this.contextOrganizationId,
    });
    self.getTableMeta();
    self.getDictionaries();
    window.onbeforeunload = () => {
      this.$store.dispatch(VIEW_SETTINGS_SAVE);
    };

    if (this.contextIsAnonymous) {
      this.$store.dispatch(VIEW_SETTINGS_CLEAR);
    } else {
      await this.$store.dispatch(VIEW_SETTINGS_LOAD);
      this.useStoredSettings();
    }

    let mapBackgrounds = new MapBackgrounds();

    self.featurePopupOverlay = new Overlay({
      element: document.getElementById('feature-popup'),
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });

    self.featureDropdownOverlay = new Overlay({
      element: document.getElementById('feature-dropdown'),
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });

    self.multipleFeaturePopupOverlay = new Overlay({
      element: document.getElementById('multiple-feature-popup'),
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });

    CoordinateSystems.forEach((item) => {
      let projection = get(item.epsg);
      let extent = transformExtent(
        [100000, 100000, 900000, 900000],
        'EPSG:2180',
        item.epsg
      );
      projection.setExtent(extent);
    });

    const mousePositionControlTemplate = 'Y: {y}, X: {x}';
    var system = this.coordinateSystem;
    self.mousePositionControl = new MousePosition({
      coordinateFormat: function (coords) {
        return format(coords, mousePositionControlTemplate, 2);
      },
      projection: this.coordinateSystem,
      className: 'custom-mouse-position',
      target: document.getElementById('map-coordinates'),
      undefinedHTML: '&nbsp',
    });

    let overviewMapLayer = await mapBackgrounds.getOverviewMapBackground();

    self.overviewMap = new OverviewMap({
      tipLabel: 'Zamknij mapę przeglądową',
      layers: [overviewMapLayer],
      view: new View({
        projection: this.coordinateSystem,
      }),
      target: document.getElementById('overview-map'),
      collapsed: true,
    });
    // Change to collapsed false after fixing overview map
    self.initialView.zoom = this.zoom;
    self.initialView.projection = this.coordinateSystem;
    self.initialView.center = this.viewCenter;
    self.initialView.resolution = this.resolution;

    self.map = new OLMap({
      target: 'map',
      overlays: [self.featurePopupOverlay, self.featureDropdownOverlay, self.multipleFeaturePopupOverlay],
      view: new View({
        zoom: self.initialView.zoom,
        maxZoom: 13,
        // zoomFactor: 1,
        projection: self.initialView.projection,
        center: self.initialView.center,
        resolution: self.initialView.resolution,
      }),
      controls: defaults({
        attributionOptions: {
          collapsible: false,
        },
        zoom: true,
        zoomOptions: {
          zoomInTipLabel: 'Przybliż',
          zoomOutTipLabel: 'Oddal',
          target: document.getElementById('map-zoom'),
        },
      }).extend([
        self.mousePositionControl,
        new ScaleLine({
          target: document.getElementById('map-scale'),
        }),
        self.overviewMap,
      ]),
    });
    self.map.on('moveend', function () {
      self.$store.dispatch(MAP_CURRENT_VIEW_SET, self.map);
      self.$store.commit(
        MAP_RESOLUTION_SET,
        self.map.getView().getResolution()
      );
      self.$store.commit(VIEW_CENTER_SET, self.map.getView().getCenter());

      if (self.$store.getters.editSession) {
        self.updateSnapFeatures();
      }
      const newZoom = self.map.getView().getZoom();
      if (self.currentZoom != newZoom) {
        self.$store.commit(FEATURES_TILE_LAYERS_FEATURES_SET, {});
        self.currentZoom = newZoom;
      }
    });

    self.$store.dispatch(KEYSHORTCUTS_FETCH);
    self.$store.dispatch(READ_ONLY_GET);
    self.$store.dispatch(TOOLS_FETCH);
    self.$store.dispatch(RESPONSIVENESS_MANAGER_TRIGGER);

    this.map.on('click', (event) => {
      if (this.isSelectModePoint && !this.editSession) {
        this.$notify({ clean: true });

        this.$store.dispatch(SINGLE_CLICK_SELECTION_APPLY, {
          map: this.map,
          event: event,
          self: this,
        });
      } else {
        this.$notify({ clean: true });

        this.$store.dispatch(WMS_GET_FEATURE_INFO, {
          map: this.map,
          event: event,
          self: this,
        });
      }

      this.$store.dispatch(ADD_FEATURE_POINT, event.coordinate);
      this.$store.dispatch(ROAD_LANE_FEATURE_ADD_POINT, event.coordinate);
      this.$store.commit(CONNECTION_ADD_FEATURE_POINT, event.coordinate);
      this.$store.dispatch(SET_FEATURE_GEOMETRY_ADD_POINT, event.coordinate);
    });

    self.map.on('pointermove', (evt) => {
      self.$store.commit(SET_FEATURE_ENDING, evt.coordinate);
      self.$store.commit(ROAD_LANE_FEATURE_SET_ENDING, evt.coordinate);
      self.$store.commit(CONNECTION_SET_FEATURE_ENDING, evt.coordinate);
      self.$store.commit(
        SET_FEATURE_GEOMETRY_FEATURE_SET_ENDING,
        evt.coordinate
      );
    });

    self.map.on('dblclick', (evt) => {
      if (
        self.poleAnalysisReady ||
        self.connectionAnalysisLaunched ||
        self.setFeatureGeometryActive
      ) {
        evt.preventDefault();
      } else if (self.roadLaneAnalysisStarted) {
        evt.preventDefault();
        self.$store.dispatch(ROAD_LANE_FEATURE_END_DRAWING);
      }
    });

    this.toggleSelectMode(MODE_POINT);

    this.$store.dispatch(FETCH_ALL_LAYERS, {
      useStoredSettings: !this.contextIsAnonymous,
    });
    const mouseWheelZoom = new MouseWheelZoom();
    self.map.addInteraction(mouseWheelZoom);
    self.mapMounted = true;
  },
  created() {
    let self = this;

    self.$store.watch(
      () => self.$store.getters.isHistoryDataMode,
      (value, oldValue) => {
        if (oldValue && !value) {
          self.resetHistoricData();
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.coordinateSystem,
      (value, oldValue) => self.setCoordinateSystem(oldValue, value)
    );

    self.$store.watch(
      () => self.$store.getters.zoom,
      (value, oldValue) => self.setZoom(value)
    );

    self.$store.watch(
      () => self.$store.getters.layers,
      (value, oldValue) => {
        let oldLayers = oldValue || [];
        let layers = value || [];
        oldLayers.forEach(function (item) {
          self.map.removeLayer(item.mapLayer);

          if (item.mapHighResolutionLayer) {
            self.map.removeLayer(item.mapHighResolutionLayer);
          }

          if (item.mapHistoricalLayer) {
            self.map.removeLayer(item.mapHistoricalLayer);
          }
        });

        layers
          .filter((item) => item.group !== 'tymczasowa')
          .forEach(function (item) {
            if (item.mapLayer) {
              self.map.addLayer(item.mapLayer);
            }

            if (item.mapHighResolutionLayer) {
              self.map.addLayer(item.mapHighResolutionLayer);
            }

            if (item.mapHistoricalLayer) {
              self.map.addLayer(item.mapHistoricalLayer);
            }
          });

        if (value.length > 0) {
          // zasilenia masowe/manualne
          let dataFeedId = this.getParamValueFromUrl('idZasilenia');
          let dataFeedType = this.getParamValueFromUrl('typZasilenia');
          if (dataFeedId != null && dataFeedType != null) {
            self.$store.commit(DATA_FEED_ID_SET, dataFeedId);
            self.$store.commit(DATA_FEED_TYPE_SET, dataFeedType);
            this.$store.commit(LEFT_RESIZABLE_PANEL_EXPAND_CHANGE, true);
          }
          // zasilenia bez geometrii
          let noGeometryModeLayerId = this.getParamValueFromUrl('idWarstwy');
          if (noGeometryModeLayerId != null) {
            self.$store.commit(
              DATA_FEED_NO_GEOMETRY_LAYER_ID_SET,
              noGeometryModeLayerId
            );
          }
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.currentShortcuts,
      (value, oldValue) => {
        if (value.indexOf(KeyShortcuts.zoomIn) >= 0) {
          var zoom = self.map.getView().getZoom();
          self.setZoom(zoom + 1);
        } else if (value.indexOf(KeyShortcuts.zoomOut) >= 0) {
          var zoom = self.map.getView().getZoom();
          self.setZoom(zoom - 1);
        }

        if (value.indexOf(KeyShortcuts.hideLegend) >= 0) {
          self.$refs.legend.collapse();
        } else if (value.indexOf(KeyShortcuts.showLegend) >= 0) {
          self.$refs.legend.expand();
        }

        if (value.indexOf(KeyShortcuts.initialView) >= 0) {
          self.map.getView().setCenter(self.initialView.center);
          self.setZoom(self.initialView.zoom);
        }

        if (value.indexOf(KeyShortcuts.reportDiscrepancy) >= 0) {
          self.toggleMismatchApplicationVisibility();
        }

        if (self.featuresTableActive) {
          if (value.indexOf(KeyShortcuts.maximizeTable) >= 0) {
            self.$refs['resizable-attr-table'].setHigher();
          } else if (value.indexOf(KeyShortcuts.minimizeTable) >= 0) {
            self.$refs['resizable-attr-table'].setLower();
          }
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.zoomInTool,
      (value) => self.showZoomTool(value, '.ol-zoom-in')
    );

    self.$store.watch(
      () => self.$store.getters.zoomOutTool,
      (value) => self.showZoomTool(value, '.ol-zoom-out')
    );

    self.$store.watch(
      () => self.$store.getters.resolution,
      (value, oldValue) => self.setResolution(value)
    );

    self.$store.watch(
      () => self.$store.getters.rangeSelectionActive,
      (value) => {
        if (value) {
          let source = new VectorSource({ wrapX: false });
          self.reportSelection.layer = new VectorLayer({
            source: source,
            zIndex: Infinity,
            style: new Style({
              fill: new Fill({ color: 'rgba(188, 216, 83, 0.4)' }),
              stroke: new Stroke({
                color: 'rgba(188, 216, 83, 0.8)',
                width: 3,
              }),
              image: new RegularShape({
                fill: new Fill({ color: 'rgba(188, 216, 83, 0.4)' }),
                stroke: new Stroke({
                  color: 'rgba(188, 216, 83, 0.8)',
                  width: 4,
                }),
                points: 4,
                radius: 10,
                radius2: 0,
                angle: 0,
              }),
            }),
          });

          self.map.addLayer(self.reportSelection.layer);

          self.reportSelection.drawInteraction = new Draw({
            source: source,
            type: 'Circle',
            geometryFunction: createBox(),
            style: self.reportSelection.layer.getStyle(),
          });

          self.reportSelection.drawInteraction.on('drawstart', function () {
            self.reportSelection.layer.getSource().clear();
          });

          self.map.addInteraction(self.reportSelection.drawInteraction);
        } else {
          let selection = self.reportSelection.layer
            .getSource()
            .getFeatures()[0];

          if (selection) {
            self.$store.commit(REPORTS_RANGE_SET, selection.getGeometry());
          }

          self.map.removeInteraction(self.reportSelection.drawInteraction);
          self.map.removeLayer(self.reportSelection.layer);
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.validationChoosenObject,
      (value) => {
        if (value) {
          self.onValidationReportObjectChoosen(value.featureId, value.isGeo);
          self.onValidationReportErrorClicked(value);
          self.$store.commit(
            REPORT_VALIDATION_CHOOSEN_OBJECT_PROPERTIES_SET,
            undefined
          );
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.poleAnalysisReady,
      (v) => (v ? self.startPoleAnalysis() : self.stopPoleAnalysis())
    );

    self.$store.watch(
      () => self.$store.getters.viewCenter,
      (v) => {
        if (self.map) {
          const currentCenter = self.map.getView().getCenter();

          if (v[0] != currentCenter[0] || v[1] != currentCenter[1]) {
            self.map.getView().setCenter(v);
          }
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.measurementsEnabled,
      (enabled) => {
        if (enabled) {
          self.map.addInteraction(
            self.$store.getters.measurementDrawInteraction
          );
        } else {
          self.map.removeInteraction(
            self.$store.getters.measurementDrawInteraction
          );
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.selectedAddressSearchItem,
      (value, oldValue) => {
        self.onAddressSearchObjectChoosen(value);
        if (value != null && value != {}) self.leftPanelExpandUpdate(false);
      }
    );

    self.$store.watch(
      () => self.$store.getters.featuresWithCoordinates,
      async (value) => await self.onFeaturesFound(value)
    );

    self.$store.watch(
      () => self.$store.getters.mileageSearchResultObject,
      (value) => self.onMileageSearchObjectChoosen(value)
    );

    self.$store.watch(
      () => self.$store.getters.coordinateSearchResultObject,
      async (value) => await self.onCoordinateSearchObjectChoosen(value)
    );

    self.$store.watch(
      () => self.$store.getters.terytParcelSearchResultObject,
      (value) => self.onTerytParcelSearchObjectChoosen(value)
    );

    self.$store.watch(
      () => self.$store.getters.terytSearchResultObject,
      (value) => self.onTerytSearchObjectChoosen(value)
    );

    self.$store.watch(
      () => self.$store.getters.featurePopupPosition,
      (value, oldValue) => {
        if (value !== oldValue && !this.isMobileDevice) {
          self.featurePopupOverlay.setPosition(value);
        }
      }
    );
    self.$store.watch(
      () => self.$store.getters.featureDropdownPosition,
      (value, oldValue) => {
        if (value !== oldValue && !this.isMobileDevice) {
          self.featureDropdownOverlay.setPosition(value);
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.multipleFeaturePopupPosition,
      (value, oldValue) => {
        if (value !== oldValue) {
          self.multipleFeaturePopupOverlay.setPosition(value);
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.featurePopupLayerActive,
      (value, oldValue) => {
        if (value !== oldValue && !value) {
          self.$store.commit(SELECT_FEATURE_POPUP_HIDE);
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.mismatchAreaModeEnabled,
      (value) => {
        if (value) {
          self.startMismatchInteraction('Polygon');
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.mismatchPointModeEnabled,
      (value) => {
        if (value) {
          self.startMismatchInteraction('Point');
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.setFeatureGeometryReady,
      (value) => {
        if (value === true) {
          // self.startSetFeatureGeometryInteraction();
        } else if (value === false) {
          self.clearSetFeatureGeometryDrawInteractionSource();
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.mismatchObjectsModeEnabled,
      (value) => {
        if (value) {
          self.endMismatchInteraction();
          if (!this.isSelectModePoint) {
            self.toggleSelectMode(MODE_POINT);
          }
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.poleAnalysisDrawingEnded,
      (value) => {
        if (value) {
          self.onPoleAnalysisDrawEnded();
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.roadLaneAnalysisStarted,
      (value) => {
        value
          ? self.onRoadLaneAnalysisStarted()
          : self.onRoadLaneAnalysisEnded();
      }
    );

    self.$store.watch(
      () => self.$store.getters.roadLaneAnalysisDrawingEnded,
      (value) => {
        if (value) self.onRoadLaneAnalysisDrawingEnded();
      }
    );

    self.$store.watch(
      () => self.$store.getters.connectionAnalysisLaunched,
      (v) =>
        v ? self.startConnectionAnalysis() : self.stopConnectionAnalysis()
    );

    self.$store.watch(
      () => self.$store.getters.connectionanalysisDrawingEnded,
      (value) => {
        if (value) {
          self.onConnectionAnalysisDrawEnded();
        }
      }
    );

    self.$store.watch(
      () => self.$store.getters.isSelectModeRectangle,
      (value, oldValue) => {
        if (value && !oldValue) {
          self.$notify({
            type: 'info',
            title: 'Informacja.',
            text: 'Aby zaznaczyć obiekty prostokątem wskaż pierwszy wierzchołek, a następnie wierzchołek po przekątnej.',
            duration: -1,
          });
        }
        if (!value && oldValue) {
          this.$notify({
            clean: true,
          });
        }
      }
    );

    self.$store.watch(
      () => self.selectedMapFeatures,
      (value, oldValue) => {
        // this.editLayerSelectedCollection.forEach(element => {
        //   this.$store.commit(EDIT_SESSION_FEATURE_DESELECTED, element);
        // });

        this.editLayerSelectedCollection.clear();

        // if (this.editedActiveLayer) {
        // this.editedActiveLayer
        //   .getSource()
        //   .getFeatures()
        //   .forEach(element => {
        //     if (value.has(element.getId())) {
        //       this.editLayerSelectedCollection.push(element);
        //       this.$store.commit(EDIT_SESSION_FEATURE_SELECTED, element);
        //     }
        //   });
        // this.editedActiveLayer.changed();
        // }

        this.editedObjects = this.editLayerSelectedCollection.getArray();

        let firstSelected = (this.$store.getters.selectedFeatures || [])[0];

        this.$store.commit(FEATURES_OFFSET_SET, firstSelected);
      }
    );

    self.$store.watch(
      () => self.$store.getters.decision,
      (value, oldValue) => self.showDecision(value)
    );

    self.$store.watch(
      () => self.$store.getters.forceResizablePanelExpand,
      (value, oldValue) => {
        if (value === true) {
          if (self.$refs['resizable-attr-table']) {
            self.$refs['resizable-attr-table'].forceExpand();
          }
          self.$store.commit(RESIZABLE_PANEL_FORCE_EXPANDED_SET, false);
        }
      }
    );
  },
};
</script>

<style>
.map-view {
  position: relative;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
  min-height: 0;
}

#map-view-container {
  position: absolute; /* Hack - Safari won't set child element's height to 100% when parent's height is 'auto'*/
  height: 100%; /* Hack - but it works for child elements with position 'absolute' */
  width: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
}

#map {
  -webkit-flex: 1;
  flex: 1;
  position: absolute;
  inset: 0;
}

#map-zoom {
  position: relative;
  pointer-events: all;
  -webkit-align-self: flex-start;
  align-self: flex-start;
}

#search-panel-results {
  pointer-events: all;
  margin-bottom: 16px;
  position: sticky;
  top: 0;
  max-width: 40vw;
  max-height: 50vh;
}

.panel-container {
  position: absolute;
  top: 0;
  left: 0;
  display: -webkit-flex;
  display: flex;
  height: 100%;
  width: 100%;
  pointer-events: none;
  overflow: hidden;
  z-index: 2;
  -webkit-flex: 1;
  flex: 1;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -webkit-align-items: flex-end;
  align-items: flex-end;
}
.ol-overviewmap-box {
  border-color: rgba(255, 0, 0, 1);
  background-color: rgba(255, 0, 0, 0.2);
}

.ol-zoom * {
  width: 1.8em !important;
  height: 1.8em !important;
  border-radius: 2px !important;
}

.ol-zoom-in:not(.showZoom) {
  display: none !important;
}

.ol-zoom-out:not(.showZoom) {
  display: none !important;
}

#map-zoom,
#overview-map {
  position: relative;
  pointer-events: all;
}
#map-zoom {
  margin-right: auto;
}

#edit-mode-overlay {
  position: fixed;
  margin-left: 40%;
  margin-top: 2%;
  width: 20%;
  height: 5%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  text-align: center;
}

.expand-toolbar-enter-active {
  transition: all 0.5s ease;
  max-height: 60px;
}

.expand-toolbar-enter {
  max-height: 0px;
}

#overview-map .ol-overviewmap button {
  display: none;
}

.ol-overviewmap.ol-collapsed {
  display: none;
}

#edit-mode-overlay > h3 {
  font-weight: 600;
  line-height: 1.75em;
}

.edit-mode-header {
  line-height: initial;
  margin: 0;
}

.tooltip-measurement {
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  color: white;
  padding: 4px 8px;
  opacity: 0.7;
  white-space: nowrap;
  z-index: 0;
}

.tooltip-measure {
  opacity: 1;
  font-weight: bold;
}

#left-panel-placeholder {
  background-color: rgba(255, 255, 255, 0.85);
  margin-bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-flex: 1;
  flex: 1;
  -webkit-justify-content: center;
  justify-content: center;
  text-align: center;
  height: 100%;
}

.placeholderWarning {
  margin: 1em;
  font-weight: bold;
}
.map-objects-group {
  /* position: relative; */
  /* pointer-events: all; */
  /* -webkit-align-self: flex-start;
   align-self: flex-start; */
  align-items: end;
  display: flex;
  flex-direction: column;
}
</style>
